window.theme = window.theme || {};
window.theme = window.theme || {};
theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
    $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
}
;
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');
        constructor = constructor || this.constructors[type];
        if (_.isUndefined(constructor)) {
            return;
        }
        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });
        this.instances.push(instance);
    },
    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },
    _onSectionUnload: function(evt) {
        this.instances = _.filter(this.instances, function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }
            return !isEventInstance;
        });
    },
    _onSelect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },
    _onDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },
    _onBlockSelect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },
    _onBlockDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });
        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },
    register: function(type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function(index, container) {
            this._createInstance(container, constructor);
        }
        .bind(this));
    }
});
window.slate = window.slate || {};
slate.utils = {
    getParameterByName: function(name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
          , results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
    }
};
window.slate = window.slate || {};
slate.rte = {
    wrapTable: function(options) {
        options.$tables.wrap('<div class="' + options.tableWrapperClass + '"></div>');
    },
    wrapIframe: function(options) {
        options.$iframes.each(function() {
            $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
            this.src = this.src;
        });
    }
};
window.slate = window.slate || {};
slate.a11y = {
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';
        $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);
        function callback() {
            $element.first().removeClass(focusClass).removeAttr('tabindex');
        }
    },
    focusHash: function() {
        var hash = window.location.hash;
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },
    bindInPageLinks: function() {
        $('a[href*=#]').on('click', function(evt) {
            this.pageLinkFocus($(evt.currentTarget.hash));
        }
        .bind(this));
    },
    trapFocus: function(options) {
        var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace ? 'focusout.' + options.namespace : 'focusout',
            keydown: options.namespace ? 'keydown.' + options.namespace : 'keydown.handleFocus'
        };
        var $focusableElements = options.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(':visible'));
        var firstFocusable = $focusableElements[0];
        var lastFocusable = $focusableElements[$focusableElements.length - 1];
        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }
        function _manageFocus(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.TAB)
                return;
            if (evt.target === lastFocusable && !evt.shiftKey) {
                evt.preventDefault();
                firstFocusable.focus();
            }
            if (evt.target === firstFocusable && evt.shiftKey) {
                evt.preventDefault();
                lastFocusable.focus();
            }
        }
        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();
        $(document).off('focusin');
        $(document).on(eventsName.focusout, function() {
            $(document).off(eventsName.keydown);
        });
        $(document).on(eventsName.focusin, function(evt) {
            if (evt.target !== lastFocusable && evt.target !== firstFocusable)
                return;
            $(document).on(eventsName.keydown, function(evt) {
                _manageFocus(evt);
            });
        });
    },
    removeTrapFocus: function(options) {
        var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';
        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }
        $(document).off(eventName);
    },
    accessibleLinks: function(options) {
        var body = document.querySelector('body');
        var idSelectors = {
            newWindow: 'a11y-new-window-message',
            external: 'a11y-external-message',
            newWindowExternal: 'a11y-new-window-external-message'
        };
        if (options.$links === undefined || !options.$links.jquery) {
            options.$links = $('a[href]:not([aria-describedby])');
        }
        function generateHTML(customMessages) {
            if (typeof customMessages !== 'object') {
                customMessages = {};
            }
            var messages = $.extend({
                newWindow: 'Opens in a new window.',
                external: 'Opens external website.',
                newWindowExternal: 'Opens external website in a new window.'
            }, customMessages);
            var container = document.createElement('ul');
            var htmlMessages = '';
            for (var message in messages) {
                htmlMessages += '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
            }
            container.setAttribute('hidden', true);
            container.innerHTML = htmlMessages;
            body.appendChild(container);
        }
        function _externalSite($link) {
            var hostname = window.location.hostname;
            return $link[0].hostname !== hostname;
        }
        $.each(options.$links, function() {
            var $link = $(this);
            var target = $link.attr('target');
            var rel = $link.attr('rel');
            var isExternal = _externalSite($link);
            var isTargetBlank = target === '_blank';
            if (isExternal) {
                $link.attr('aria-describedby', idSelectors.external);
            }
            if (isTargetBlank) {
                if (rel === undefined || rel.indexOf('noopener') === -1) {
                    $link.attr('rel', function(i, val) {
                        var relValue = val === undefined ? '' : val + ' ';
                        return relValue + 'noopener';
                    });
                }
                $link.attr('aria-describedby', idSelectors.newWindow);
            }
            if (isExternal && isTargetBlank) {
                $link.attr('aria-describedby', idSelectors.newWindowExternal);
            }
        });
        generateHTML(options.messages);
    }
};
theme.Images = (function() {
    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }
    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);
        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }
    function imageSize(src) {
        var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
        if (match !== null) {
            if (match[2] !== undefined) {
                return match[1] + match[2];
            } else {
                return match[1];
            }
        } else {
            return null;
        }
    }
    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }
        if (size === 'master') {
            return this.removeProtocol(src);
        }
        var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match !== null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }
        return null;
    }
    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }
    return {
        preload: preload,
        loadImage: loadImage,
        switchImage: switchImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
}
)();
theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;
        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';
            if (isNaN(number) || number === null) {
                return 0;
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? decimal + parts[1] : '';
            return dollarsAmount + centsAmount;
        }
        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }
        return formatString.replace(placeholderRegex, value);
    }
    return {
        formatMoney: formatMoney
    };
}
)();
slate.Variants = (function() {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();
        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    }
    Variants.prototype = _.assignIn({}, Variants.prototype, {
        _getCurrentOptions: function() {
            var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
                var $element = $(element);
                var type = $element.attr('type');
                var currentOption = {};
                if (type === 'radio' || type === 'checkbox') {
                    if ($element[0].checked) {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');
                        return currentOption;
                    } else {
                        return false;
                    }
                } else {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');
                    return currentOption;
                }
            });
            currentOptions = _.compact(currentOptions);
            return currentOptions;
        },
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;
            var found = _.find(variants, function(variant) {
                return selectedValues.every(function(values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });
            return found;
        },
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();
            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });
            if (!variant) {
                return;
            }
            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;
            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },
        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};
            if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
                return;
            }
            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },
        _updatePrice: function(variant) {
            if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
                return;
            }
            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },
        _updateSKU: function(variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }
            this.$container.trigger({
                type: 'variantSKUChange',
                variant: variant
            });
        },
        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({
                path: newurl
            }, '', newurl);
        },
        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        }
    });
    return Variants;
}
)();
theme.Drawers = (function() {
    function Drawer(id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };
        this.nodes = {
            $parent: $('html').add('body'),
            $page: $('#PageContainer')
        };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $('#' + id);
        if (!this.$drawer.length) {
            return false;
        }
        this.drawerIsOpen = false;
        this.init();
    }
    Drawer.prototype.init = function() {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    }
    ;
    Drawer.prototype.open = function(evt) {
        var externalCall = false;
        if (evt) {
            evt.preventDefault();
        } else {
            externalCall = true;
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget);
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close();
        }
        this.$drawer.prepareTransition();
        this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });
        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
            if (!externalCall) {
                this.config.onDrawerOpen();
            }
        }
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }
        this.bindEvents();
        return this;
    }
    ;
    Drawer.prototype.close = function() {
        if (!this.drawerIsOpen) {
            return;
        }
        $(document.activeElement).trigger('blur');
        this.$drawer.prepareTransition();
        this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false');
        }
        this.drawerIsOpen = false;
        slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus'
        });
        this.unbindEvents();
        if (this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
            this.config.onDrawerClose();
        }
    }
    ;
    Drawer.prototype.bindEvents = function() {
        this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
            if (evt.keyCode === 27) {
                this.close();
                return false;
            } else {
                return true;
            }
        }, this));
        this.nodes.$page.on('touchmove.drawer', function() {
            return false;
        });
        this.nodes.$page.on('click.drawer', $.proxy(function() {
            this.close();
            return false;
        }, this));
    }
    ;
    Drawer.prototype.unbindEvents = function() {
        this.nodes.$page.off('.drawer');
        this.nodes.$parent.off('.drawer');
    }
    ;
    return Drawer;
}
)();
window.theme = window.theme || {};
theme.Header = (function() {
    var selectors = {
        body: 'body',
        multicurrencySelector: '[data-currency-selector]',
        navigation: '#AccessibleNav',
        siteNavHasDropdown: '[data-has-dropdowns]',
        siteNavChildLinks: '.site-nav__child-link',
        siteNavActiveDropdown: '.site-nav--active-dropdown1',
        siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
        siteNavCenteredDropdown: '.site-nav__dropdown--centered',
        siteNavLinkMain: '.site-nav__link--main',
        siteNavChildLink: '.site-nav__link--last',
        siteNavDropdown: '.site-nav__dropdown',
        siteHeader: '.site-header'
    };
    var config = {
        activeClass: 'site-nav--active-dropdown1',
        childLinkClass: 'site-nav__child-link',
        rightDropdownClass: 'site-nav__dropdown--right',
        leftDropdownClass: 'site-nav__dropdown--left'
    };
    var cache = {};
    function init() {
        cacheSelectors();
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
        cache.$parents.on('click.siteNav', function() {
            var $el = $(this);
            $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
        });
        $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
            setTimeout(function() {
                if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
                    return;
                }
                hideDropdown(cache.$activeDropdown);
            });
        });
        cache.$topLevel.on('focus.siteNav', function() {
            if (cache.$activeDropdown.length) {
                hideDropdown(cache.$activeDropdown);
            }
        });
        cache.$subMenuLinks.on('click.siteNav', function(evt) {
            evt.stopImmediatePropagation();
        });
        $(selectors.multicurrencySelector).on('change', function() {
            $(this).parents('form').submit();
        });
        $(window).resize($.debounce(50, function() {
            styleDropdowns($(selectors.siteNavHasDropdown));
            positionFullWidthDropdowns();
        }));
    }
    function cacheSelectors() {
        cache = {
            $nav: $(selectors.navigation),
            $topLevel: $(selectors.siteNavLinkMain),
            $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
            $subMenuLinks: $(selectors.siteNavChildLinks),
            $activeDropdown: $(selectors.siteNavActiveDropdown),
            $siteHeader: $(selectors.siteHeader)
        };
    }
    function showDropdown($el) {
        $el.addClass(config.activeClass);
        if (cache.$activeDropdown.length) {
            hideDropdown(cache.$activeDropdown);
        }
        cache.$activeDropdown = $el;
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');
        setTimeout(function() {
            $(window).on('keyup.siteNav', function(evt) {
                if (evt.keyCode === 27) {
                    hideDropdown($el);
                }
            });
            $(selectors.body).on('click.siteNav', function() {
                hideDropdown($el);
            });
        }, 250);
    }
    function hideDropdown($el) {
        $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
        $el.removeClass(config.activeClass);
        cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
        $(selectors.body).off('click.siteNav');
        $(window).off('keyup.siteNav');
    }
    function styleDropdowns($dropdownListItems) {
        $dropdownListItems.each(function() {
            var $dropdownLi = $(this).find(selectors.siteNavDropdown);
            if (!$dropdownLi.length) {
                return;
            }
            var isRightOfLogo = Math.ceil($(this).offset().left) > Math.floor(cache.$siteHeader.outerWidth()) / 2 ? true : false;
            if (isRightOfLogo) {
                $dropdownLi.removeClass(config.leftDropdownClass).addClass(config.rightDropdownClass);
            } else {
                $dropdownLi.removeClass(config.rightDropdownClass).addClass(config.leftDropdownClass);
            }
        });
    }
    function positionFullWidthDropdowns() {
        var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);
        $listWithCenteredDropdown.each(function() {
            var $hasCenteredDropdown = $(this);
            var $fullWidthDropdown = $hasCenteredDropdown.find(selectors.siteNavCenteredDropdown);
            var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
            $fullWidthDropdown.css('top', fullWidthDropdownOffset);
        });
    }
    function unload() {
        $(window).off('.siteNav');
        cache.$parents.off('.siteNav');
        cache.$subMenuLinks.off('.siteNav');
        cache.$topLevel.off('.siteNav');
        $(selectors.siteNavChildLink).off('.siteNav');
        $(selectors.body).off('.siteNav');
    }
    return {
        init: init,
        unload: unload
    };
}
)();
window.theme = window.theme || {};
theme.MobileNav = (function() {
    var classes = {
        mobileNavOpenIcon: 'mobile-nav--open',
        mobileNavCloseIcon: 'mobile-nav--close',
        navLinkWrapper: 'mobile-nav__item',
        navLink: 'mobile-nav__link',
        subNavLink: 'mobile-nav__sublist-link',
        return: 'mobile-nav__return-btn',
        subNavActive: 'is-active',
        subNavClosing: 'is-closing',
        navOpen: 'js-menu--is-open',
        subNavShowing: 'sub-nav--is-open',
        thirdNavShowing: 'third-nav--is-open',
        subNavToggleBtn: 'js-toggle-submenu'
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    var mediaQuerySmall = 'screen and (max-width: 749px)';
    function init() {
        cacheSelectors();
        cache.$mobileNavToggle.on('click', toggleMobileNav);
        cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);
        enquire.register(mediaQuerySmall, {
            unmatch: function() {
                if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
                    closeMobileNav();
                }
            }
        });
    }
    function toggleMobileNav() {
        if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    }
    function cacheSelectors() {
        cache = {
            $pageContainer: $('#PageContainer'),
            $siteHeader: $('.site-header'),
            $mobileNavToggle: $('.js-mobile-nav-toggle'),
            $mobileNavContainer: $('.mobile-nav-wrapper'),
            $mobileNav: $('#MobileNav'),
            $sectionHeader: $('#shopify-section-header'),
            $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
        };
    }
    function openMobileNav() {
        var translateHeaderHeight = cache.$siteHeader.outerHeight();
        var scroll = $(window).scrollTop();
        var announcment = $('div#fsb_background');
        if (announcment.length == 0) {} else {
            if (scroll <= 44) {
                var translateHeaderHeight = translateHeaderHeight + 44;
            } else if (scroll >= 45) {
                var translateHeaderHeight = cache.$siteHeader.outerHeight();
            }
        }
        console.log(translateHeaderHeight);
        cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
        cache.$mobileNavContainer.css({
            transform: 'translateY(' + translateHeaderHeight + 'px)'
        });
        cache.$pageContainer.css({
            transform: 'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
        });
        slate.a11y.trapFocus({
            $container: cache.$sectionHeader,
            $elementToFocus: cache.$mobileNavToggle,
            namespace: 'navFocus'
        });
        cache.$mobileNavToggle.addClass(classes.mobileNavCloseIcon).removeClass(classes.mobileNavOpenIcon).attr('aria-expanded', true);
        $(window).on('keyup.mobileNav', function(evt) {
            if (evt.which === 27) {
                closeMobileNav();
            }
        });
    }
    function closeMobileNav() {
        cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
        cache.$mobileNavContainer.css({
            transform: 'translateY(-100%)'
        });
        cache.$pageContainer.removeAttr('style');
        slate.a11y.trapFocus({
            $container: $('html'),
            $elementToFocus: $('body')
        });
        cache.$mobileNavContainer.one('TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle', function() {
            slate.a11y.removeTrapFocus({
                $container: cache.$mobileNav,
                namespace: 'navFocus'
            });
        });
        cache.$mobileNavToggle.addClass(classes.mobileNavOpenIcon).removeClass(classes.mobileNavCloseIcon).attr('aria-expanded', false).focus();
        $(window).off('keyup.mobileNav');
        //scrollTo(0, 0);
    }
    function toggleSubNav(evt) {
        if (isTransitioning) {
            return;
        }
        var $toggleBtn = $(evt.currentTarget);
        var isReturn = $toggleBtn.hasClass(classes.return);
        isTransitioning = true;
        if (isReturn) {
            $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]').removeClass(classes.subNavActive);
            if ($activeTrigger && $activeTrigger.length) {
                $activeTrigger.removeClass(classes.subNavActive);
            }
        } else {
            $toggleBtn.addClass(classes.subNavActive);
        }
        $activeTrigger = $toggleBtn;
        goToSubnav($toggleBtn.data('target'));
    }
    function goToSubnav(target) {
        var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
        menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;
        if ($activeSubNav && $activeSubNav.length) {
            $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
        }
        $activeSubNav = $targetMenu;
        var translateMenuHeight = $targetMenu.outerHeight();
        var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
        cache.$mobileNavContainer.css('height', translateMenuHeight).removeClass(classes.thirdNavShowing).addClass(openNavClass);
        if (!target) {
            cache.$mobileNavContainer.removeClass(classes.thirdNavShowing).removeClass(classes.subNavShowing);
        }
        var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;
        var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
        var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;
        cache.$mobileNavContainer.one('TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle', function() {
            slate.a11y.trapFocus({
                $container: $container,
                $elementToFocus: $elementToFocus,
                namespace: 'subNavFocus'
            });
            cache.$mobileNavContainer.off('.subnavToggle');
            isTransitioning = false;
        });
        cache.$pageContainer.css({
            transform: 'translateY(' + translateMenuHeight + 'px)'
        });
        $activeSubNav.removeClass(classes.subNavClosing);
    }
    return {
        init: init,
        closeMobileNav: closeMobileNav
    };
}
)(jQuery);
window.theme = window.theme || {};
theme.Search = (function() {
    var selectors = {
        search: '.search',
        searchSubmit: '.search__submit',
        searchInput: '.search__input',
        siteHeader: '.site-header',
        siteHeaderSearchToggle: '.site-header__search-toggle',
        siteHeaderSearch: '.site-header__search',
        searchDrawer: '.search-bar',
        searchDrawerInput: '.search-bar__input',
        searchHeader: '.search-header',
        searchHeaderInput: '.search-header__input',
        searchHeaderSubmit: '.search-header__submit',
        searchResultSubmit: '#SearchResultSubmit',
        searchResultInput: '#SearchInput',
        searchResultMessage: '[data-search-error-message]',
        mobileNavWrapper: '.mobile-nav-wrapper'
    };
    var classes = {
        focus: 'search--focus',
        hidden: 'hide',
        mobileNavIsOpen: 'js-menu--is-open',
        searchTemplate: 'template-search'
    };
    function init() {
        if (!$(selectors.siteHeader).length) {
            return;
        }
        this.$searchResultInput = $(selectors.searchResultInput);
        this.$searchErrorMessage = $(selectors.searchResultMessage);
        initDrawer();
        var isSearchPage = slate.utils.getParameterByName('q') !== null && $('body').hasClass(classes.searchTemplate);
        if (isSearchPage) {
            validateSearchResultForm.call(this);
        }
        $(selectors.searchResultSubmit).on('click', validateSearchResultForm.bind(this));
        $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
            $(selectors.searchHeader).toggleClass(classes.focus);
        });
        $(selectors.siteHeaderSearchToggle).on('click', function() {
            var searchHeight = $(selectors.siteHeader).outerHeight();
            var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
            $(selectors.searchDrawer).css({
                height: searchHeight + 'px',
                top: searchOffset + 'px'
            });
        });
    }
    function initDrawer() {
        $('#PageContainer').addClass('drawer-page-content');
        $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false').attr('aria-haspopup', 'dialog');
        theme.SearchDrawer = new theme.Drawers('SearchDrawer','top',{
            onDrawerOpen: searchDrawerFocus,
            onDrawerClose: searchDrawerFocusClose
        });
    }
    function searchDrawerFocus() {
        searchFocus($(selectors.searchDrawerInput));
        if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
            theme.MobileNav.closeMobileNav();
        }
    }
    function searchFocus($el) {
        $el.focus();
        $el[0].setSelectionRange(0, $el[0].value.length);
    }
    function searchDrawerFocusClose() {
        $(selectors.siteHeaderSearchToggle).focus();
    }
    function hideErrorMessage() {
        this.$searchErrorMessage.addClass(classes.hidden);
        this.$searchResultInput.removeAttr('aria-describedby').removeAttr('aria-invalid');
    }
    function showErrorMessage() {
        this.$searchErrorMessage.removeClass(classes.hidden);
        this.$searchResultInput.attr('aria-describedby', 'error-search-form').attr('aria-invalid', true);
    }
    function validateSearchResultForm(evt) {
        var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;
        if (!isInputValueEmpty) {
            hideErrorMessage.call(this);
            return;
        }
        if (typeof evt !== 'undefined') {
            evt.preventDefault();
        }
        searchFocus(this.$searchResultInput);
        showErrorMessage.call(this);
    }
    return {
        init: init
    };
}
)();
(function() {
    var selectors = {
        backButton: '.return-link'
    };
    var $backButton = $(selectors.backButton);
    if (!document.referrer || !$backButton.length || !window.history.length) {
        return;
    }
    $backButton.one('click', function(evt) {
        evt.preventDefault();
        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);
        if (shopDomain === referrerDomain) {
            history.back();
        }
        return false;
    });
    function urlDomain(url) {
        var anchor = document.createElement('a');
        anchor.ref = url;
        return anchor.hostname;
    }
}
)();
theme.Slideshow = (function() {
    this.$slideshow = null;
    var classes = {
        slideshow: 'slideshow',
        slickActiveMobile: 'slick-active-mobile',
        controlsHover: 'slideshow__controls--hover',
        isPaused: 'is-paused'
    };
    var selectors = {
        section: '.shopify-section',
        wrapper: '#SlideshowWrapper-',
        slides: '.slideshow__slide',
        textWrapperMobile: '.slideshow__text-wrap--mobile',
        textContentMobile: '.slideshow__text-content--mobile',
        controls: '.slideshow__controls',
        pauseButton: '.slideshow__pause',
        dots: '.slick-dots',
        arrows: '.slideshow__arrows',
        arrowsMobile: '.slideshow__arrows--mobile',
        arrowLeft: '.slideshow__arrow-left',
        arrowRight: '.slideshow__arrow-right'
    };
    function slideshow(el, sectionId) {
        var $slideshow = (this.$slideshow = $(el));
        this.adaptHeight = this.$slideshow.data('adapt-height');
        this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
        this.$section = this.$wrapper.closest(selectors.section);
        this.$controls = this.$wrapper.find(selectors.controls);
        this.$arrows = this.$section.find(selectors.arrows);
        this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
        this.$pause = this.$controls.find(selectors.pauseButton);
        this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
        this.autorotate = this.$slideshow.data('autorotate');
        var autoplaySpeed = this.$slideshow.data('speed');
        var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
        this.settings = {
            accessibility: true,
            arrows: false,
            dots: true,
            fade: true,
            draggable: true,
            touchThreshold: 20,
            autoplay: this.autorotate,
            autoplaySpeed: autoplaySpeed,
            appendDots: this.$arrows,
            customPaging: function(slick, index) {
                return ('<a href="' + selectors.wrapper + sectionId + '" aria-label="' + loadSlideA11yString.replace('[slide_number]', index + 1) + '" data-slide-number="' + index + '"></a>');
            }
        };
        this.$slideshow.on('beforeChange', beforeChange.bind(this));
        this.$slideshow.on('init', slideshowA11ySetup.bind(this));
        this.$slideshow.on('init', function() {
            this.$mobileDots.find('li:first-of-type').addClass(classes.slickActiveMobile);
            this.showMobileText(0);
        }
        .bind(this));
        if (this.autorotate) {
            $(document).scroll($.debounce(250, function() {
                if (this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset) {
                    $slideshow.slick('slickPause');
                } else if (!this.$pause.hasClass(classes.isPaused)) {
                    $slideshow.slick('slickPlay');
                }
            }
            .bind(this)));
        }
        if (this.adaptHeight) {
            this.setSlideshowHeight();
            $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
        }
        this.$slideshow.slick(this.settings);
        slideshowPostInitA11ySetup.bind(this)();
        this.$arrows.find(selectors.arrowLeft).on('click', function() {
            $slideshow.slick('slickPrev');
        });
        this.$arrows.find(selectors.arrowRight).on('click', function() {
            $slideshow.slick('slickNext');
        });
        this.$pause.on('click', this.togglePause.bind(this));
    }
    function slideshowA11ySetup(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        this.$dots = this.$section.find(selectors.dots);
        this.$mobileDots = this.$dots.eq(1);
        $list.removeAttr('aria-live');
        this.$wrapper.on('keyup', keyboardNavigation.bind(this));
        this.$controls.on('keyup', keyboardNavigation.bind(this));
        this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));
        this.$wrapper.on('focusin', function(evt) {
            if (!this.$wrapper.has(evt.target).length) {
                return;
            }
            $list.attr('aria-live', 'polite');
            if (this.autorotate) {
                $slider.slick('slickPause');
            }
        }
        .bind(this)).on('focusout', function(evt) {
            if (!this.$wrapper.has(evt.target).length) {
                return;
            }
            $list.removeAttr('aria-live');
            if (this.autorotate) {
                if (!this.$pause.is('.is-paused')) {
                    $slider.slick('slickPlay');
                }
            }
        }
        .bind(this));
        if (this.$dots) {
            this.$dots.find('a').each(function() {
                var $dot = $(this);
                $dot.on('click keyup', function(evt) {
                    if (evt.type === 'keyup' && evt.which !== slate.utils.keyboardKeys.ENTER)
                        return;
                    evt.preventDefault();
                    var slideNumber = $(evt.target).data('slide-number');
                    $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);
                    if (evt.type === 'keyup') {
                        $slider.focus();
                    }
                });
            }).eq(0).attr('aria-current', 'true');
        }
        this.$controls.on('focusin', highlightControls.bind(this)).on('focusout', unhighlightControls.bind(this));
    }
    function slideshowPostInitA11ySetup() {
        var $slides = this.$slideshow.find(selectors.slides);
        $slides.removeAttr('role').removeAttr('aria-labelledby');
        this.$dots.removeAttr('role').find('li').removeAttr('role').removeAttr('aria-selected').each(function() {
            var $dot = $(this);
            var ariaControls = $dot.attr('aria-controls');
            $dot.removeAttr('aria-controls').find('a').attr('aria-controls', ariaControls);
        });
    }
    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $dotLinks = this.$dots.find('a');
        var $mobileDotLinks = this.$mobileDots.find('li');
        $dotLinks.removeAttr('aria-current').eq(nextSlide).attr('aria-current', 'true');
        $mobileDotLinks.removeClass(classes.slickActiveMobile).eq(nextSlide).addClass(classes.slickActiveMobile);
        this.showMobileText(nextSlide);
    }
    function keyboardNavigation() {
        if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
            this.$slideshow.slick('slickPrev');
        }
        if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
            this.$slideshow.slick('slickNext');
        }
    }
    function highlightControls() {
        this.$controls.addClass(classes.controlsHover);
    }
    function unhighlightControls() {
        this.$controls.removeClass(classes.controlsHover);
    }
    slideshow.prototype.togglePause = function() {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
            if (this.autorotate) {
                $(slideshowSelector).slick('slickPlay');
            }
        } else {
            this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
            if (this.autorotate) {
                $(slideshowSelector).slick('slickPause');
            }
        }
    }
    ;
    slideshow.prototype.setSlideshowHeight = function() {
        var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
        this.$slideshow.height($(document).width() / minAspectRatio);
    }
    ;
    slideshow.prototype.showMobileText = function(slideIndex) {
        var $allTextContent = this.$textWrapperMobile.find(selectors.textContentMobile);
        var currentTextContentSelector = selectors.textContentMobile + '-' + slideIndex;
        var $currentTextContent = this.$textWrapperMobile.find(currentTextContentSelector);
        if (!$currentTextContent.length && this.$slideshow.find(selectors.slides).length === 1) {
            this.$textWrapperMobile.hide();
        } else {
            this.$textWrapperMobile.show();
        }
        $allTextContent.hide();
        $currentTextContent.show();
    }
    ;
    function getSlideshowId($el) {
        return '#Slideshow-' + $el.data('id');
    }
    return slideshow;
}
)();
function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos();
}
theme.Video = (function() {
    var autoplayCheckComplete = false;
    var playOnClickChecked = false;
    var playOnClick = false;
    var youtubeLoaded = false;
    var videos = {};
    var videoPlayers = [];
    var videoOptions = {
        ratio: 16 / 9,
        scrollAnimationDuration: 400,
        playerVars: {
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
        },
        events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerChange
        }
    };
    var classes = {
        playing: 'video-is-playing',
        paused: 'video-is-paused',
        loading: 'video-is-loading',
        loaded: 'video-is-loaded',
        backgroundVideoWrapper: 'video-background-wrapper',
        videoWithImage: 'video--image_with_play',
        backgroundVideo: 'video--background',
        userPaused: 'is-paused',
        supportsAutoplay: 'autoplay',
        supportsNoAutoplay: 'no-autoplay',
        wrapperMinHeight: 'video-section-wrapper--min-height'
    };
    var selectors = {
        section: '.video-section',
        videoWrapper: '.video-section-wrapper',
        playVideoBtn: '.video-control__play',
        closeVideoBtn: '.video-control__close-wrapper',
        pauseVideoBtn: '.video__pause',
        pauseVideoStop: '.video__pause-stop',
        pauseVideoResume: '.video__pause-resume',
        fallbackText: '.icon__fallback-text'
    };
    function init($video) {
        if (!$video.length) {
            return;
        }
        videos[$video.attr('id')] = {
            id: $video.attr('id'),
            videoId: $video.data('id'),
            type: $video.data('type'),
            status: $video.data('type') === 'image_with_play' ? 'closed' : 'background',
            $video: $video,
            $videoWrapper: $video.closest(selectors.videoWrapper),
            $section: $video.closest(selectors.section),
            controls: $video.data('type') === 'background' ? 0 : 1
        };
        if (!youtubeLoaded) {
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        playOnClickCheck();
    }
    function customPlayVideo(playerId) {
        if (!playOnClickChecked && !playOnClick) {
            return;
        }
        if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
            privatePlayVideo(playerId);
        }
    }
    function pauseVideo(playerId) {
        if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
            videoPlayers[playerId].pauseVideo();
        }
    }
    function loadVideos() {
        for (var key in videos) {
            if (videos.hasOwnProperty(key)) {
                createPlayer(key);
            }
        }
        initEvents();
        youtubeLoaded = true;
    }
    function editorLoadVideo(key) {
        if (!youtubeLoaded) {
            return;
        }
        createPlayer(key);
        initEvents();
    }
    function privatePlayVideo(id, clicked) {
        var videoData = videos[id];
        var player = videoPlayers[id];
        var $videoWrapper = videoData.$videoWrapper;
        if (playOnClick) {
            setAsPlaying(videoData);
        } else if (clicked || autoplayCheckComplete) {
            $videoWrapper.removeClass(classes.loading);
            setAsPlaying(videoData);
            player.playVideo();
            return;
        } else {
            player.playVideo();
        }
    }
    function setAutoplaySupport(supported) {
        var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
        $(document.documentElement).removeClass(classes.supportsAutoplay).removeClass(classes.supportsNoAutoplay).addClass(supportClass);
        if (!supported) {
            playOnClick = true;
        }
        autoplayCheckComplete = true;
    }
    function playOnClickCheck() {
        if (playOnClickChecked) {
            return;
        }
        if (isMobile()) {
            playOnClick = true;
        }
        if (playOnClick) {
            setAutoplaySupport(false);
        }
        playOnClickChecked = true;
    }
    function onPlayerReady(evt) {
        evt.target.setPlaybackQuality('hd1080');
        var videoData = getVideoOptions(evt);
        var videoTitle = evt.target.getVideoData().title;
        playOnClickCheck();
        $('#' + videoData.id).attr('tabindex', '-1');
        sizeBackgroundVideos();
        setButtonLabels(videoData.$videoWrapper, videoTitle);
        if (videoData.type === 'background') {
            evt.target.mute();
            privatePlayVideo(videoData.id);
        }
        videoData.$videoWrapper.addClass(classes.loaded);
    }
    function onPlayerChange(evt) {
        var videoData = getVideoOptions(evt);
        if (videoData.status === 'background' && !isMobile() && !autoplayCheckComplete && (evt.data === YT.PlayerState.PLAYING || evt.data === YT.PlayerState.BUFFERING)) {
            setAutoplaySupport(true);
            autoplayCheckComplete = true;
            videoData.$videoWrapper.removeClass(classes.loading);
        }
        switch (evt.data) {
        case YT.PlayerState.ENDED:
            setAsFinished(videoData);
            break;
        case YT.PlayerState.PAUSED:
            setTimeout(function() {
                if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
                    setAsPaused(videoData);
                }
            }, 200);
            break;
        }
    }
    function setAsFinished(videoData) {
        switch (videoData.type) {
        case 'background':
            videoPlayers[videoData.id].seekTo(0);
            break;
        case 'image_with_play':
            closeVideo(videoData.id);
            toggleExpandVideo(videoData.id, false);
            break;
        }
    }
    function setAsPlaying(videoData) {
        var $videoWrapper = videoData.$videoWrapper;
        var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
        $videoWrapper.removeClass(classes.loading);
        if ($pauseButton.hasClass(classes.userPaused)) {
            $pauseButton.removeClass(classes.userPaused);
        }
        if (videoData.status === 'background') {
            return;
        }
        $('#' + videoData.id).attr('tabindex', '0');
        if (videoData.type === 'image_with_play') {
            $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
        }
        setTimeout(function() {
            $videoWrapper.find(selectors.closeVideoBtn).focus();
        }, videoOptions.scrollAnimationDuration);
    }
    function setAsPaused(videoData) {
        var $videoWrapper = videoData.$videoWrapper;
        if (videoData.type === 'image_with_play') {
            if (videoData.status === 'closed') {
                $videoWrapper.removeClass(classes.paused);
            } else {
                $videoWrapper.addClass(classes.paused);
            }
        }
        $videoWrapper.removeClass(classes.playing);
    }
    function closeVideo(playerId) {
        var videoData = videos[playerId];
        var $videoWrapper = videoData.$videoWrapper;
        var classesToRemove = [classes.paused, classes.playing].join(' ');
        if (isMobile()) {
            $videoWrapper.removeAttr('style');
        }
        $('#' + videoData.id).attr('tabindex', '-1');
        videoData.status = 'closed';
        switch (videoData.type) {
        case 'image_with_play':
            videoPlayers[playerId].stopVideo();
            setAsPaused(videoData);
            break;
        case 'background':
            videoPlayers[playerId].mute();
            setBackgroundVideo(playerId);
            break;
        }
        $videoWrapper.removeClass(classesToRemove);
    }
    function getVideoOptions(evt) {
        return videos[evt.target.a.id];
    }
    function toggleExpandVideo(playerId, expand) {
        var video = videos[playerId];
        var elementTop = video.$videoWrapper.offset().top;
        var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
        var offset = 0;
        var newHeight = 0;
        if (isMobile()) {
            video.$videoWrapper.parent().toggleClass('page-width', !expand);
        }
        if (expand) {
            if (isMobile()) {
                newHeight = $(window).width() / videoOptions.ratio;
            } else {
                newHeight = video.$videoWrapper.width() / videoOptions.ratio;
            }
            offset = ($(window).height() - newHeight) / 2;
            video.$videoWrapper.removeClass(classes.wrapperMinHeight).animate({
                height: newHeight
            }, 600);
            if (!(isMobile() && Shopify.designMode)) {
                $('html, body').animate({
                    scrollTop: elementTop - offset
                }, videoOptions.scrollAnimationDuration);
            }
        } else {
            if (isMobile()) {
                newHeight = video.$videoWrapper.data('mobile-height');
            } else {
                newHeight = video.$videoWrapper.data('desktop-height');
            }
            video.$videoWrapper.height(video.$videoWrapper.width() / videoOptions.ratio).animate({
                height: newHeight
            }, 600);
            setTimeout(function() {
                video.$videoWrapper.addClass(classes.wrapperMinHeight);
            }, 600);
            $playButton.focus();
        }
    }
    function togglePause(playerId) {
        var $pauseButton = videos[playerId].$videoWrapper.find(selectors.pauseVideoBtn);
        var paused = $pauseButton.hasClass(classes.userPaused);
        if (paused) {
            $pauseButton.removeClass(classes.userPaused);
            customPlayVideo(playerId);
        } else {
            $pauseButton.addClass(classes.userPaused);
            pauseVideo(playerId);
        }
        $pauseButton.attr('aria-pressed', !paused);
    }
    function startVideoOnClick(playerId) {
        var video = videos[playerId];
        video.$videoWrapper.addClass(classes.loading);
        video.$videoWrapper.attr('style', 'height: ' + video.$videoWrapper.height() + 'px');
        video.status = 'open';
        switch (video.type) {
        case 'image_with_play':
            privatePlayVideo(playerId, true);
            break;
        case 'background':
            unsetBackgroundVideo(playerId, video);
            videoPlayers[playerId].unMute();
            privatePlayVideo(playerId, true);
            break;
        }
        toggleExpandVideo(playerId, true);
        $(document).on('keydown.videoPlayer', function(evt) {
            var playerId = $(document.activeElement).data('controls');
            if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
                return;
            }
            closeVideo(playerId);
            toggleExpandVideo(playerId, false);
        });
    }
    function sizeBackgroundVideos() {
        $('.' + classes.backgroundVideo).each(function(index, el) {
            sizeBackgroundVideo($(el));
        });
    }
    function sizeBackgroundVideo($videoPlayer) {
        if (!youtubeLoaded) {
            return;
        }
        if (isMobile()) {
            $videoPlayer.removeAttr('style');
        } else {
            var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
            var videoWidth = $videoWrapper.width();
            var playerWidth = $videoPlayer.width();
            var desktopHeight = $videoWrapper.data('desktop-height');
            if (videoWidth / videoOptions.ratio < desktopHeight) {
                playerWidth = Math.ceil(desktopHeight * videoOptions.ratio);
                $videoPlayer.width(playerWidth).height(desktopHeight).css({
                    left: (videoWidth - playerWidth) / 2,
                    top: 0
                });
            } else {
                desktopHeight = Math.ceil(videoWidth / videoOptions.ratio);
                $videoPlayer.width(videoWidth).height(desktopHeight).css({
                    left: 0,
                    top: (desktopHeight - desktopHeight) / 2
                });
            }
            $videoPlayer.prepareTransition();
            $videoWrapper.addClass(classes.loaded);
        }
    }
    function unsetBackgroundVideo(playerId) {
        $('#' + playerId).removeClass(classes.backgroundVideo).addClass(classes.videoWithImage);
        setTimeout(function() {
            $('#' + playerId).removeAttr('style');
        }, 600);
        videos[playerId].$videoWrapper.removeClass(classes.backgroundVideoWrapper).addClass(classes.playing);
        videos[playerId].status = 'open';
    }
    function setBackgroundVideo(playerId) {
        $('#' + playerId).removeClass(classes.videoWithImage).addClass(classes.backgroundVideo);
        videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);
        videos[playerId].status = 'background';
        sizeBackgroundVideo($('#' + playerId));
    }
    function isMobile() {
        return $(window).width() < 750 || window.mobileCheck();
    }
    function initEvents() {
        $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
            var playerId = $(evt.currentTarget).data('controls');
            startVideoOnClick(playerId);
        });
        $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
            var playerId = $(evt.currentTarget).data('controls');
            $(evt.currentTarget).blur();
            closeVideo(playerId);
            toggleExpandVideo(playerId, false);
        });
        $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
            var playerId = $(evt.currentTarget).data('controls');
            togglePause(playerId);
        });
        $(window).on('resize.videoPlayer', $.debounce(200, function() {
            if (!youtubeLoaded)
                return;
            var key;
            var fullscreen = window.innerHeight === screen.height;
            sizeBackgroundVideos();
            if (isMobile()) {
                for (key in videos) {
                    if (videos.hasOwnProperty(key)) {
                        if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                            if (!fullscreen) {
                                pauseVideo(key);
                                setAsPaused(videos[key]);
                            }
                        }
                        videos[key].$videoWrapper.height($(document).width() / videoOptions.ratio);
                    }
                }
                setAutoplaySupport(false);
            } else {
                setAutoplaySupport(true);
                for (key in videos) {
                    if (videos[key].$videoWrapper.find('.' + classes.videoWithImage).length) {
                        continue;
                    }
                    videoPlayers[key].playVideo();
                    setAsPlaying(videos[key]);
                }
            }
        }));
        $(window).on('scroll.videoPlayer', $.debounce(50, function() {
            if (!youtubeLoaded)
                return;
            for (var key in videos) {
                if (videos.hasOwnProperty(key)) {
                    var $videoWrapper = videos[key].$videoWrapper;
                    if ($videoWrapper.hasClass(classes.playing) && ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 < $(window).scrollTop() || $videoWrapper.offset().top + $videoWrapper.height() * 0.25 > $(window).scrollTop() + $(window).height())) {
                        closeVideo(key);
                        toggleExpandVideo(key, false);
                    }
                }
            }
        }));
    }
    function createPlayer(key) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key,args);
    }
    function removeEvents() {
        $(document).off('.videoPlayer');
        $(window).off('.videoPlayer');
    }
    function setButtonLabels($videoWrapper, title) {
        var $playButtons = $videoWrapper.find(selectors.playVideoBtn);
        var $closeButton = $videoWrapper.find(selectors.closeVideoBtn);
        var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
        var $closeButtonText = $closeButton.find(selectors.fallbackText);
        var $pauseButtonStopText = $pauseButton.find(selectors.pauseVideoStop).find(selectors.fallbackText);
        var $pauseButtonResumeText = $pauseButton.find(selectors.pauseVideoResume).find(selectors.fallbackText);
        $playButtons.each(function() {
            var $playButton = $(this);
            var $playButtonText = $playButton.find(selectors.fallbackText);
            $playButtonText.text($playButtonText.text().replace('[video_title]', title));
        });
        $closeButtonText.text($closeButtonText.text().replace('[video_title]', title));
        $pauseButtonStopText.text($pauseButtonStopText.text().replace('[video_title]', title));
        $pauseButtonResumeText.text($pauseButtonResumeText.text().replace('[video_title]', title));
    }
    return {
        init: init,
        editorLoadVideo: editorLoadVideo,
        loadVideos: loadVideos,
        playVideo: customPlayVideo,
        pauseVideo: pauseVideo,
        removeEvents: removeEvents
    };
}
)();
window.theme = window.theme || {};
theme.FormStatus = (function() {
    var selectors = {
        statusMessage: '[data-form-status]'
    };
    function init() {
        this.$statusMessage = $(selectors.statusMessage);
        if (!this.$statusMessage)
            return;
        this.$statusMessage.attr('tabindex', -1).focus();
        this.$statusMessage.on('blur', handleBlur.bind(this));
    }
    function handleBlur() {
        this.$statusMessage.removeAttr('tabindex');
    }
    return {
        init: init
    };
}
)();
theme.Hero = (function() {
    var classes = {
        indexSectionFlush: 'index-section--flush'
    };
    var selectors = {
        heroFixedWidthContent: '.hero-fixed-width__content',
        heroFixedWidthImage: '.hero-fixed-width__image'
    };
    function hero(el, sectionId) {
        this.$hero = $(el);
        this.layout = this.$hero.data('layout');
        var $parentSection = $('#shopify-section-' + sectionId);
        var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
        var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);
        if (this.layout !== 'fixed_width') {
            return;
        }
        $parentSection.removeClass(classes.indexSectionFlush);
        heroFixedHeight();
        $(window).resize($.debounce(50, function() {
            heroFixedHeight();
        }));
        function heroFixedHeight() {
            var contentHeight = $heroContent.height() + 50;
            var imageHeight = $heroImage.height();
            if (contentHeight > imageHeight) {
                $heroImage.css('min-height', contentHeight);
            }
        }
    }
    return hero;
}
)();
(function() {
    var $filterBy = $('#BlogTagFilter');
    if (!$filterBy.length) {
        return;
    }
    $filterBy.on('change', function() {
        location.href = $(this).val();
    });
}
)();
window.theme = theme || {};
theme.customerTemplates = (function() {
    var selectors = {
        RecoverHeading: '#RecoverHeading',
        RecoverEmail: '#RecoverEmail',
        LoginHeading: '#LoginHeading'
    };
    function initEventListeners() {
        this.$RecoverHeading = $(selectors.RecoverHeading);
        this.$RecoverEmail = $(selectors.RecoverEmail);
        this.$LoginHeading = $(selectors.LoginHeading);
        $('#RecoverPassword').on('click', function(evt) {
            evt.preventDefault();
            showRecoverPasswordForm();
            this.$RecoverHeading.attr('tabindex', '-1').focus();
        }
        .bind(this));
        $('#HideRecoverPasswordLink').on('click', function(evt) {
            evt.preventDefault();
            hideRecoverPasswordForm();
            this.$LoginHeading.attr('tabindex', '-1').focus();
        }
        .bind(this));
        this.$RecoverHeading.on('blur', function() {
            $(this).removeAttr('tabindex');
        });
        this.$LoginHeading.on('blur', function() {
            $(this).removeAttr('tabindex');
        });
    }
    function showRecoverPasswordForm() {
        $('#RecoverPasswordForm').removeClass('hide');
        $('#CustomerLoginForm').addClass('hide');
        if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
            this.$RecoverEmail.focus();
        }
    }
    function hideRecoverPasswordForm() {
        $('#RecoverPasswordForm').addClass('hide');
        $('#CustomerLoginForm').removeClass('hide');
    }
    function resetPasswordSuccess() {
        var $formState = $('.reset-password-success');
        if (!$formState.length) {
            return;
        }
        $('#ResetSuccess').removeClass('hide').focus();
    }
    function customerAddressForm() {
        var $newAddressForm = $('#AddressNewForm');
        var $newAddressFormButton = $('#AddressNewButton');
        if (!$newAddressForm.length) {
            return;
        }
        if (Shopify) {
            new Shopify.CountryProvinceSelector('AddressCountryNew','AddressProvinceNew',{
                hideElement: 'AddressProvinceContainerNew'
            });
        }
        $('.address-country-option').each(function() {
            var formId = $(this).data('form-id');
            var countrySelector = 'AddressCountry_' + formId;
            var provinceSelector = 'AddressProvince_' + formId;
            var containerSelector = 'AddressProvinceContainer_' + formId;
            new Shopify.CountryProvinceSelector(countrySelector,provinceSelector,{
                hideElement: containerSelector
            });
        });
        $('.address-new-toggle').on('click', function() {
            var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';
            $newAddressForm.toggleClass('hide');
            $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
        });
        $('.address-edit-toggle').on('click', function() {
            var formId = $(this).data('form-id');
            var $editButton = $('#EditFormButton_' + formId);
            var $editAddress = $('#EditAddress_' + formId);
            var isExpanded = $editButton.attr('aria-expanded') === 'true';
            $editAddress.toggleClass('hide');
            $editButton.attr('aria-expanded', !isExpanded).focus();
        });
        $('.address-delete').on('click', function() {
            var $el = $(this);
            var target = $el.data('target');
            var confirmMessage = $el.data('confirm-message');
            if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
                Shopify.postLink(target, {
                    parameters: {
                        _method: 'delete'
                    }
                });
            }
        });
    }
    function checkUrlHash() {
        var hash = window.location.hash;
        if (hash === '#recover') {
            showRecoverPasswordForm.bind(this)();
        }
    }
    return {
        init: function() {
            initEventListeners();
            checkUrlHash();
            resetPasswordSuccess();
            customerAddressForm();
        }
    };
}
)();
window.theme = window.theme || {};
theme.Cart = (function() {
    var selectors = {
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartDiscount: '[data-cart-discount]',
        cartDiscountTitle: '[data-cart-discount-title]',
        cartDiscountAmount: '[data-cart-discount-amount]',
        cartDiscountWrapper: '[data-cart-discount-wrapper]',
        cartErrorMessage: '[data-cart-error-message]',
        cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
        cartItem: '[data-cart-item]',
        cartItemDetails: '[data-cart-item-details]',
        cartItemDiscount: '[data-cart-item-discount]',
        cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
        cartItemDiscountTitle: '[data-cart-item-discount-title]',
        cartItemDiscountAmount: '[data-cart-item-discount-amount]',
        cartItemDiscountList: '[data-cart-item-discount-list]',
        cartItemFinalPrice: '[data-cart-item-final-price]',
        cartItemImage: '[data-cart-item-image]',
        cartItemLinePrice: '[data-cart-item-line-price]',
        cartItemOriginalPrice: '[data-cart-item-original-price]',
        cartItemPrice: '[data-cart-item-price]',
        cartItemPriceList: '[data-cart-item-price-list]',
        cartItemProperty: '[data-cart-item-property]',
        cartItemPropertyName: '[data-cart-item-property-name]',
        cartItemPropertyValue: '[data-cart-item-property-value]',
        cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
        cartItemRegularPrice: '[data-cart-item-regular-price]',
        cartItemTitle: '[data-cart-item-title]',
        cartItemOption: '[data-cart-item-option]',
        cartLineItems: '[data-cart-line-items]',
        cartNote: '[data-cart-notes]',
        cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
        cartQuantityErrorMessageWrapper: '[data-cart-quantity-error-message-wrapper]',
        cartRemove: '[data-cart-remove]',
        cartStatus: '[data-cart-status]',
        cartSubtotal: '[data-cart-subtotal]',
        cartTableCell: '[data-cart-table-cell]',
        cartWrapper: '[data-cart-wrapper]',
        emptyPageContent: '[data-empty-page-content]',
        quantityInput: '[data-quantity-input]',
        quantityInputMobile: '[data-quantity-input-mobile]',
        quantityInputDesktop: '[data-quantity-input-desktop]',
        quantityLabelMobile: '[data-quantity-label-mobile]',
        quantityLabelDesktop: '[data-quantity-label-desktop]',
        inputQty: '[data-quantity-input]',
        thumbnails: '.cart__image',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        unitPriceGroup: '[data-unit-price-group]'
    };
    var classes = {
        cartNoCookies: 'cart--no-cookies',
        cartRemovedProduct: 'cart__removed-product',
        hide: 'hide',
        inputError: 'input--error'
    };
    var attributes = {
        cartItemIndex: 'data-cart-item-index',
        cartItemKey: 'data-cart-item-key',
        cartItemQuantity: 'data-cart-item-quantity',
        cartItemTitle: 'data-cart-item-title',
        cartItemUrl: 'data-cart-item-url',
        quantityItem: 'data-quantity-item'
    };
    theme.breakpoints = theme.breakpoints || {};
    if (isNaN(theme.breakpoints.medium) || theme.breakpoints.medium === undefined) {
        theme.breakpoints.medium = 750;
    }
    var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
    function Cart(container) {
        this.$container = $(container);
        this.$thumbnails = $(selectors.thumbnails, this.$container);
        this.ajaxEnabled = this.$container.data('ajax-enabled');
        if (!this.cookiesEnabled()) {
            this.$container.addClass(classes.cartNoCookies);
        }
        this.$thumbnails.css('cursor', 'pointer');
        this.$container.on('click', selectors.thumbnails, this._handleThumbnailClick);
        this.$container.on('change', selectors.inputQty, $.debounce(500, this._handleInputQty.bind(this)));
        this.mql = window.matchMedia(mediumUpQuery);
        this.mql.addListener(this.setQuantityFormControllers.bind(this));
        this.setQuantityFormControllers();
        if (this.ajaxEnabled) {
            this.$container.on('change', selectors.cartNote, this._onNoteChange.bind(this));
            this.$container.on('click', selectors.cartRemove, this._onRemoveItem.bind(this));
            this._setupCartTemplates();
        }
    }
    Cart.prototype = _.assignIn({}, Cart.prototype, {
        _setupCartTemplates: function() {
            this.$itemTemplate = $(selectors.cartItem, this.$container).first().clone();
            this.$itemDiscountTemplate = $(selectors.cartItemDiscount, this.$itemTemplate).clone();
            this.$itemOptionTemplate = $(selectors.cartItemOption, this.$itemTemplate).clone();
            this.$itemPropertyTemplate = $(selectors.cartItemProperty, this.$itemTemplate).clone();
            this.$itemPriceListTemplate = $(selectors.cartItemPriceList, this.$itemTemplate).clone();
            this.$itemLinePriceTemplate = $(selectors.cartItemLinePrice, this.$itemTemplate).clone();
            this.$cartDiscountTemplate = $(selectors.cartDiscount, this.$container).clone();
        },
        _handleInputQty: function(evt) {
            var $input = $(evt.target);
            var itemIndex = $input.data('quantity-item');
            var $itemElement = $input.closest(selectors.cartItem);
            var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
            var value = parseInt($input.val());
            var isValidValue = !(value < 0 || isNaN(value));
            $itemQtyInputs.val(value);
            this._hideCartError();
            this._hideQuantityErrorMessage();
            if (!isValidValue) {
                this._showQuantityErrorMessages($itemElement);
                return;
            }
            if (isValidValue && this.ajaxEnabled) {
                this._updateItemQuantity(itemIndex, $itemElement, $itemQtyInputs, value);
            }
        },
        _updateItemQuantity: function(itemIndex, $itemElement, $itemQtyInputs, value) {
            var key = $itemElement.attr(attributes.cartItemKey);
            var index = $itemElement.attr(attributes.cartItemIndex);
            var params = {
                url: '/cart/change.js',
                data: {
                    quantity: value,
                    line: index
                },
                dataType: 'json'
            };
            $.post(params).done(function(state) {
              setTimeout(function() {
                location.reload(true);
              }, 500);
              
//               if(typeof window.BOLD !== 'undefined'

//                  && typeof window.BOLD.common !== 'undefined'

//                  && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//                 // NOTE: "cart" should be the variable containing the cart json data

//                 state = window.BOLD.common.cartDoctor.fix(state);

//               }
                if (state.item_count === 0) {
                    this._emptyCart();
                } else {
                    this._createCart(state);
                    if (value === 0) {
                        this._showRemoveMessage($itemElement.clone());
                    } else {
                        var $lineItem = $('[data-cart-item-key="' + key + '"]');
                        var item = this.getItem(key, state);
                        $(selectors.quantityInput, $lineItem).focus();
                        this._updateLiveRegion(item);
                    }
                    console.log(state);
                    var com_price = '999999999999999999999999999';
                    $.get("https://api.ipdata.co?api-key=test", function(response) {
                        console.log(JSON.stringify(response, null, 4));
                        var country = response.country_name;
                        console.log('country: ' + country);
                        if (country == 'Canada') {
                            com_price = '20000';
                            if (state.total_price > com_price) {
                                $('.free_shipping').css('display', 'block');
                            } else {
                                $('.free_shipping').css('display', 'none');
                            }
                        } else if (country == 'United States') {
                            com_price = '4400';
                            if (state.total_price > com_price) {
                                $('.free_shipping').css('display', 'block');
                            } else {
                                $('.free_shipping').css('display', 'none');
                            }
                        }
                    }, "jsonp");
                }
                this._setCartCountBubble(state.item_count);
            }
            .bind(this)).fail(function() {
                this._showCartError($itemQtyInputs);
            }
            .bind(this));
        },
        getItem: function(key, state) {
            return state.items.find(function(item) {
                return item.key === key;
            });
        },
        _liveRegionText: function(item) {
            var liveRegionText = theme.strings.update + ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';
            liveRegionText = liveRegionText.replace('[QuantityLabel]', theme.strings.quantity).replace('[Quantity]', item.quantity);
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(item.original_line_price, theme.moneyFormat);
            var discountLabel = '';
            var discountPrice = '';
            var discountInformation = '';
            if (item.original_line_price > item.final_line_price) {
                regularLabel = theme.strings.regularTotal;
                discountLabel = theme.strings.discountedTotal;
                discountPrice = theme.Currency.formatMoney(item.final_line_price, theme.moneyFormat);
                discountInformation = theme.strings.priceColumn;
            }
            liveRegionText = liveRegionText.replace('[Regular]', regularLabel).replace('[$$]', regularPrice).replace('[DiscountedPrice]', discountLabel).replace('[$]', discountPrice).replace('[PriceInformation]', discountInformation).trim();
            return liveRegionText;
        },
        _updateLiveRegion: function(item) {
            var $liveRegion = $(selectors.cartStatus);
            $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false);
            setTimeout(function() {
                $liveRegion.attr('aria-hidden', true);
            }, 1000);
        },
        _createCart: function(state) {
            var cartDiscountList = this._createCartDiscountList(state);
            $(selectors.cartLineItems, this.$container).html(this._createLineItemList(state));
            this.setQuantityFormControllers();
            $(selectors.cartNote, this.$container).val(state.note);
            if (cartDiscountList.length === 0) {
                $(selectors.cartDiscountWrapper, this.$container).html('').addClass(classes.hide);
            } else {
                $(selectors.cartDiscountWrapper, this.$container).html(cartDiscountList).removeClass(classes.hide);
            }
            $(selectors.cartSubtotal, this.$container).html(theme.Currency.formatMoney(state.total_price, theme.moneyFormatWithCurrency));
        },
        _createCartDiscountList: function(cart) {
            return $.map(cart.cart_level_discount_applications, function(discount) {
                var $discount = this.$cartDiscountTemplate.clone();
                $discount.find(selectors.cartDiscountTitle).text(discount.title);
                $discount.find(selectors.cartDiscountAmount).html(theme.Currency.formatMoney(discount.total_allocated_amount, theme.moneyFormat));
                return $discount[0];
            }
            .bind(this));
        },
        _createLineItemList: function(state) {
            return $.map(state.items, function(item, index) {
                var $item = this.$itemTemplate.clone();
                var $itemPriceList = this.$itemPriceListTemplate.clone();
                this._setLineItemAttributes($item, item, index);
                this._setLineItemImage($item, item.featured_image);
                $(selectors.cartItemTitle, $item).text(item.product_title).attr('href', item.url);
                var productDetailsList = this._createProductDetailsList(item.product_has_only_default_variant, item.options_with_values, item.properties);
                this._setProductDetailsList($item, productDetailsList);
                this._setItemRemove($item, item.title);
                $itemPriceList.html(this._createItemPrice(item.original_price, item.final_price, this.$itemPriceListTemplate));
                if (item.unit_price_measurement) {
                    $itemPriceList.append(this._createUnitPrice(item.unit_price, item.unit_price_measurement, this.$itemPriceListTemplate));
                }
                this._setItemPrice($item, $itemPriceList);
                var itemDiscountList = this._createItemDiscountList(item);
                this._setItemDiscountList($item, itemDiscountList);
                this._setQuantityInputs($item, item, index);
                var itemLinePrice = this._createItemPrice(item.original_line_price, item.final_line_price, this.$itemLinePriceTemplate);
                this._setItemLinePrice($item, itemLinePrice);
                return $item[0];
            }
            .bind(this));
        },
        _setLineItemAttributes: function($item, item, index) {
            $item.attr(attributes.cartItemKey, item.key).attr(attributes.cartItemUrl, item.url).attr(attributes.cartItemTitle, item.title).attr(attributes.cartItemIndex, index + 1).attr(attributes.cartItemQuantity, item.quantity);
        },
        _setLineItemImage: function($item, featuredImage) {
            var $image = $(selectors.cartItemImage, $item);
            var sizedImageUrl = featuredImage.url !== null ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190') : null;
            if (sizedImageUrl) {
                $image.attr('alt', featuredImage.alt).attr('src', sizedImageUrl).removeClass(classes.hide);
            } else {
                $image.remove();
            }
        },
        _setProductDetailsList: function($item, productDetailsList) {
            var $itemDetails = $(selectors.cartItemDetails, $item);
            if (productDetailsList.length === 0) {
                $itemDetails.addClass(classes.hide).text('');
            } else {
                $itemDetails.removeClass(classes.hide).html(productDetailsList);
            }
        },
        _setItemPrice: function($item, price) {
            $(selectors.cartItemPrice, $item).html(price);
        },
        _setItemDiscountList: function($item, discountList) {
            var $itemDiscountList = $(selectors.cartItemDiscountList, $item);
            if (discountList.length === 0) {
                $itemDiscountList.html('').addClass(classes.hide);
            } else {
                $itemDiscountList.html(discountList).removeClass(classes.hide);
            }
        },
        _setItemRemove: function($item, title) {
            $(selectors.cartRemove, $item).attr('aria-label', theme.strings.removeLabel.replace('[product]', title));
        },
        _setQuantityInputs: function($item, item, index) {
            $(selectors.quantityInputMobile, $item).attr('id', 'updates_' + item.key).attr(attributes.quantityItem, index + 1).val(item.quantity);
            $(selectors.quantityInputDesktop, $item).attr('id', 'updates_large_' + item.key).attr(attributes.quantityItem, index + 1).val(item.quantity);
            $(selectors.quantityLabelMobile, $item).attr('for', 'updates_' + item.key);
            $(selectors.quantityLabelDesktop, $item).attr('for', 'updates_large_' + item.key);
        },
        setQuantityFormControllers: function() {
            if (this.mql.matches) {
                $(selectors.quantityInputDesktop).attr('name', 'updates[]');
                $(selectors.quantityInputMobile).removeAttr('name');
            } else {
                $(selectors.quantityInputMobile).attr('name', 'updates[]');
                $(selectors.quantityInputDesktop).removeAttr('name');
            }
        },
        _setItemLinePrice: function($item, price) {
            $(selectors.cartItemLinePrice, $item).html(price);
        },
        _createProductDetailsList: function(product_has_only_default_variant, options, properties) {
            var optionsPropertiesHTML = [];
            if (!product_has_only_default_variant) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(this._getOptionList(options));
            }
            if (properties !== null && Object.keys(properties).length !== 0) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(this._getPropertyList(properties));
            }
            return optionsPropertiesHTML;
        },
        _getOptionList: function(options) {
            return $.map(options, function(option) {
                var $optionElement = this.$itemOptionTemplate.clone();
                $optionElement.text(option.name + ': ' + option.value).removeClass(classes.hide);
                return $optionElement[0];
            }
            .bind(this));
        },
        _getPropertyList: function(properties) {
            var propertiesArray = properties !== null ? Object.entries(properties) : [];
            return $.map(propertiesArray, function(property) {
                var $propertyElement = this.$itemPropertyTemplate.clone();
                if (property[0].charAt(0) === '_')
                    return;
                if (property[1].length === 0)
                    return;
                $propertyElement.find(selectors.cartItemPropertyName).text(property[0]);
                if (property[0].indexOf('/uploads/') === -1) {
                    $propertyElement.find(selectors.cartItemPropertyValue).text(': ' + property[1]);
                } else {
                    $propertyElement.find(selectors.cartItemPropertyValue).html(': <a href="' + property[1] + '"> ' + property[1].split('/').pop() + '</a>');
                }
                $propertyElement.removeClass(classes.hide);
                return $propertyElement[0];
            }
            .bind(this));
        },
        _createItemPrice: function(original_price, final_price, $priceTemplate) {
            if (original_price !== final_price) {
                var $discountedPrice = $(selectors.cartItemDiscountedPriceGroup, $priceTemplate).clone();
                $(selectors.cartItemOriginalPrice, $discountedPrice).html(theme.Currency.formatMoney(original_price, theme.moneyFormat));
                $(selectors.cartItemFinalPrice, $discountedPrice).html(theme.Currency.formatMoney(final_price, theme.moneyFormat));
                $discountedPrice.removeClass(classes.hide);
                return $discountedPrice[0];
            } else {
                var $regularPrice = $(selectors.cartItemRegularPriceGroup, $priceTemplate).clone();
                $(selectors.cartItemRegularPrice, $regularPrice).html(theme.Currency.formatMoney(original_price, theme.moneyFormat));
                $regularPrice.removeClass(classes.hide);
                return $regularPrice[0];
            }
        },
        _createUnitPrice: function(unitPrice, unitPriceMeasurement, $itemPriceGroup) {
            var $unitPriceGroup = $(selectors.unitPriceGroup, $itemPriceGroup).clone();
            var unitPriceBaseUnit = (unitPriceMeasurement.reference_value !== 1 ? unitPriceMeasurement.reference_value : '') + unitPriceMeasurement.reference_unit;
            $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
            $(selectors.unitPrice, $unitPriceGroup).html(theme.Currency.formatMoney(unitPrice, theme.moneyFormat));
            $unitPriceGroup.removeClass(classes.hide);
            return $unitPriceGroup[0];
        },
        _createItemDiscountList: function(item) {
            return $.map(item.line_level_discount_allocations, function(discount) {
                var $discount = this.$itemDiscountTemplate.clone();
                $discount.find(selectors.cartItemDiscountTitle).text(discount.discount_application.title);
                $discount.find(selectors.cartItemDiscountAmount).html(theme.Currency.formatMoney(discount.amount, theme.moneyFormat));
                return $discount[0];
            }
            .bind(this));
        },
        _showQuantityErrorMessages: function(itemElement) {
            $(selectors.cartQuantityErrorMessage, itemElement).text(theme.strings.quantityMinimumMessage);
            $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(classes.hide);
            $(selectors.inputQty, itemElement).addClass(classes.inputError).focus();
        },
        _hideQuantityErrorMessage: function() {
            var $errorMessages = $(selectors.cartQuantityErrorMessageWrapper).addClass(classes.hide);
            $(selectors.cartQuantityErrorMessage, $errorMessages).text('');
            $(selectors.inputQty, this.$container).removeClass(classes.inputError);
        },
        _handleThumbnailClick: function(evt) {
            var url = $(evt.target).closest(selectors.cartItem).data('cart-item-url');
            window.location.href = url;
        },
        _onNoteChange: function(evt) {
            var note = evt.currentTarget.value;
            this._hideCartError();
            this._hideQuantityErrorMessage();
            var params = {
                url: '/cart/update.js',
                data: {
                    note: note
                },
                dataType: 'json'
            };
            $.post(params).fail(function() {
                this._showCartError(evt.currentTarget);
            }
            .bind(this));
        },
        _showCartError: function(elementToFocus) {
            $(selectors.cartErrorMessage).text(theme.strings.cartError);
            $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);
            elementToFocus.focus();
        },
        _hideCartError: function() {
            $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
            $(selectors.cartErrorMessage).text('');
        },
        _onRemoveItem: function(evt) {
            evt.preventDefault();
            var $remove = $(evt.target);
            var $lineItem = $remove.closest(selectors.cartItem);
            var index = $lineItem.attr(attributes.cartItemIndex);
            this._hideCartError();
            var params = {
                url: '/cart/change.js',
                data: {
                    quantity: 0,
                    line: index
                },
                dataType: 'json'
            };
            $.post(params).done(function(state) {
              setTimeout(function() {
                location.reload(true);
              }, 500);
                if (state.item_count === 0) {
                    this._emptyCart();
                } else {
                    this._createCart(state);
                    this._showRemoveMessage($lineItem.clone());
                    console.log(state);
                    var items = state.items.length;
                    var i;
                    var com_price = '999999999999999999999999999';
                    $.get("https://api.ipdata.co?api-key=test", function(response) {
                        console.log(JSON.stringify(response, null, 4));
                        var country = response.country_name;
                        console.log('country: ' + country);
                        if (country == 'Canada') {
                            com_price = '20000';
                            if (state.total_price > com_price) {
                                $('.free_shipping').css('display', 'block');
                            } else {
                                $('.free_shipping').css('display', 'none');
                            }
                        } else if (country == 'United States') {
                            com_price = '4400';
                            if (state.total_price > com_price) {
                                $('.free_shipping').css('display', 'block');
                            } else {
                                $('.free_shipping').css('display', 'none');
                            }
                        }
                    }, "jsonp");
                }
                this._setCartCountBubble(state.item_count);
            }
            .bind(this)).fail(function() {
                this._showCartError(null);
            }
            .bind(this));
        },
        _showRemoveMessage: function(lineItem) {
            var index = lineItem.data('cart-item-index');
            var removeMessage = this._getRemoveMessage(lineItem);
            var $lineItemAtIndex;
            if (index - 1 === 0) {
                $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
                $(removeMessage).insertBefore($lineItemAtIndex);
            } else {
                $lineItemAtIndex = $('[data-cart-item-index="' + (index - 1) + '"]', this.$container);
                removeMessage.insertAfter($lineItemAtIndex);
            }
            removeMessage.focus();
        },
        _getRemoveMessage: function(lineItem) {
            var formattedMessage = this._formatRemoveMessage(lineItem);
            var $tableCell = $(selectors.cartTableCell, lineItem).clone();
            $tableCell.removeClass().addClass(classes.cartRemovedProduct).attr('colspan', '4').html(formattedMessage);
            lineItem.attr('role', 'alert').html($tableCell).attr('tabindex', '-1');
            return lineItem;
        },
        _formatRemoveMessage: function(lineItem) {
            var quantity = lineItem.data('cart-item-quantity');
            var url = lineItem.attr(attributes.cartItemUrl);
            var title = lineItem.attr(attributes.cartItemTitle);
            return theme.strings.removedItemMessage.replace('[quantity]', quantity).replace('[link]', '<a ' + 'href="' + url + '" class="text-link text-link--accent">' + title + '</a>');
        },
        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble = this.$cartCountBubble || $(selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(selectors.cartCount);
            if (quantity > 0) {
                this.$cartCountBubble.removeClass(classes.hide);
                this.$cartCount.html(quantity);
            } else {
                this.$cartCountBubble.addClass(classes.hide);
                this.$cartCount.html('');
            }
        },
        _emptyCart: function() {
            this.$emptyPageContent = this.$emptyPageContent || $(selectors.emptyPageContent, this.$container);
            this.$cartWrapper = this.$cartWrapper || $(selectors.cartWrapper, this.$container);
            this.$emptyPageContent.removeClass(classes.hide);
            this.$cartWrapper.addClass(classes.hide);
        },
        cookiesEnabled: function() {
            var cookieEnabled = navigator.cookieEnabled;
            if (!cookieEnabled) {
                document.cookie = 'testcookie';
                cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
            }
            return cookieEnabled;
        }
    });
    return Cart;
}
)();
window.theme = window.theme || {};
theme.Filters = (function() {
    var settings = {
        mediaQueryMediumUp: 'screen and (min-width: 750px)'
    };
    var selectors = {
        mainContent: '#MainContent',
        filterSelection: '#FilterTags',
        sortSelection: '#SortBy'
    };
    var data = {
        sortBy: 'data-default-sortby'
    };
    function Filters(container) {
        var $container = (this.$container = $(container));
        this.$filterSelect = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);
        this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
        this.defaultSort = this._getDefaultSortValue();
        this.$selects.removeClass('hidden');
        this.$filterSelect.on('change', this._onFilterChange.bind(this));
        this.$sortSelect.on('change', this._onSortChange.bind(this));
        this._initBreakpoints();
        this._initParams();
    }
    Filters.prototype = _.assignIn({}, Filters.prototype, {
        _initBreakpoints: function() {
            var self = this;
            enquire.register(settings.mediaQueryMediumUp, {
                match: function() {
                    self._resizeSelect(self.$selects);
                }
            });
        },
        _initParams: function() {
            self.queryParams = {};
            if (location.search.length) {
                var aKeyValue;
                var aCouples = location.search.substr(1).split('&');
                for (var i = 0; i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        self.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
        _onSortChange: function() {
            self.queryParams.sort_by = this._getSortValue();
            if (self.queryParams.page) {
                delete self.queryParams.page;
            }
            window.location.search = decodeURIComponent($.param(self.queryParams));
        },
        _onFilterChange: function() {
            document.location.href = this._getFilterValue();
        },
        _getFilterValue: function() {
            return this.$filterSelect.val();
        },
        _getSortValue: function() {
            return this.$sortSelect.val() || this.defaultSort;
        },
        _getDefaultSortValue: function() {
            return this.$sortSelect.attr(data.sortBy);
        },
        _resizeSelect: function($selection) {
            $selection.each(function() {
                var $this = $(this);
                var arrowWidth = 10;
                var text = $this.find('option:selected').text();
                var $test = $('<span>').html(text);
                $test.appendTo('body');
                var width = $test.width();
                $test.remove();
                $this.width(width + arrowWidth);
            });
        },
        onUnload: function() {
            this.$filterSelect.off('change', this._onFilterChange);
            this.$sortSelect.off('change', this._onSortChange);
        }
    });
    return Filters;
}
)();
window.theme = window.theme || {};
theme.HeaderSection = (function() {
    function Header() {
        theme.Header.init();
        theme.MobileNav.init();
        theme.Search.init();
    }
    Header.prototype = _.assignIn({}, Header.prototype, {
        onUnload: function() {
            theme.Header.unload();
        }
    });
    return Header;
}
)();
theme.Maps = (function() {
    var config = {
        zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
    var errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
    };
    var selectors = {
        section: '[data-section-type="map"]',
        map: '[data-map]',
        mapOverlay: '[data-map-overlay]'
    };
    var classes = {
        mapError: 'map-section--load-error',
        errorMsg: 'map-section__error errors text-center'
    };
    window.gm_authFailure = function() {
        if (!Shopify.designMode) {
            return;
        }
        $(selectors.section).addClass(classes.mapError);
        $(selectors.map).remove();
        $(selectors.mapOverlay).after('<div class="' + classes.errorMsg + '">' + theme.strings.authError + '</div>');
    }
    ;
    function Map(container) {
        this.$container = $(container);
        this.$map = this.$container.find(selectors.map);
        this.key = this.$map.data('api-key');
        if (typeof this.key === 'undefined') {
            return;
        }
        if (apiStatus === 'loaded') {
            this.createMap();
        } else {
            mapsToLoad.push(this);
            if (apiStatus !== 'loading') {
                apiStatus = 'loading';
                if (typeof window.google === 'undefined') {
                    $.getScript('https://maps.googleapis.com/maps/api/js?key=' + this.key).then(function() {
                        apiStatus = 'loaded';
                        initAllMaps();
                    });
                }
            }
        }
    }
    function initAllMaps() {
        $.each(mapsToLoad, function(index, instance) {
            instance.createMap();
        });
    }
    function geolocate($map) {
        var deferred = $.Deferred();
        var geocoder = new google.maps.Geocoder();
        var address = $map.data('address-setting');
        geocoder.geocode({
            address: address
        }, function(results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                deferred.reject(status);
            }
            deferred.resolve(results);
        });
        return deferred;
    }
    Map.prototype = _.assignIn({}, Map.prototype, {
        createMap: function() {
            var $map = this.$map;
            return geolocate($map).then(function(results) {
                var mapOptions = {
                    zoom: config.zoom,
                    center: results[0].geometry.location,
                    draggable: false,
                    clickableIcons: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true,
                    disableDefaultUI: true
                };
                var map = (this.map = new google.maps.Map($map[0],mapOptions));
                var center = (this.center = map.getCenter());
                var marker = new google.maps.Marker({
                    map: map,
                    position: map.getCenter()
                });
                google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(center);
                    $map.removeAttr('style');
                }));
            }
            .bind(this)).fail(function() {
                var errorMessage;
                switch (status) {
                case 'ZERO_RESULTS':
                    errorMessage = errors.addressNoResults;
                    break;
                case 'OVER_QUERY_LIMIT':
                    errorMessage = errors.addressQueryLimit;
                    break;
                case 'REQUEST_DENIED':
                    errorMessage = errors.authError;
                    break;
                default:
                    errorMessage = errors.addressError;
                    break;
                }
                if (Shopify.designMode) {
                    $map.parent().addClass(classes.mapError).html('<div class="' + classes.errorMsg + '">' + errorMessage + '</div>');
                }
            });
        },
        onUnload: function() {
            if (this.$map.length === 0) {
                return;
            }
            google.maps.event.clearListeners(this.map, 'resize');
        }
    });
    return Map;
}
)();
theme.Product = (function() {
    function Product(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        this.ajaxEnabled = $container.data('ajax-enabled');
        this.settings = {
            mediaQueryMediumUp: 'screen and (min-width: 750px)',
            mediaQuerySmall: 'screen and (max-width: 749px)',
            bpSmall: false,
            enableHistoryState: $container.data('enable-history-state') || false,
            namespace: '.slideshow-' + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false
        };
        this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
            cartPopupPlaceholderSize: '[data-placeholder-size]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupProperty: '[data-cart-popup-property]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
            originalSelectorId: '#ProductSelect-' + sectionId,
            productForm: '[data-product-form]',
            errorMessage: '[data-error-message]',
            errorMessageWrapper: '[data-error-message-wrapper]',
            productImageWraps: '.product-single__photo',
            productThumbImages: '.product-single__thumbnail--' + sectionId,
            productThumbs: '.product-single__thumbnails-' + sectionId,
            productThumbListItem: '.product-single__thumbnails-item',
            productFeaturedImage: '.product-featured-img',
            productThumbsWrapper: '.thumbnails-wrapper',
            saleLabel: '.product-price__sale-label-' + sectionId,
            singleOptionSelector: '.single-option-selector-' + sectionId,
            shopifyPaymentButton: '.shopify-payment-button',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            productPolicies: '[data-product-policies]'
        };
        this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb'
        };
        this.$quantityInput = $(this.selectors.quantity, $container);
        this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, $container);
        this.$addToCart = $(this.selectors.addToCart, $container);
        this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
        this.$shopifyPaymentButton = $(this.selectors.shopifyPaymentButton, $container);
        this.$productPolicies = $(this.selectors.productPolicies, $container);
        this.$loader = $(this.selectors.loader, this.$addToCart);
        this.$loaderStatus = $(this.selectors.loaderStatus, $container);
        if (!$('#ProductJson-' + sectionId).html()) {
            return;
        }
        this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
        this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass('js-zoom-enabled');
        this._initBreakpoints();
        this._stringOverrides();
        this._initVariants();
        this._initImageSwitch();
        this._initAddToCart();
        this._setActiveThumbnail();
    }
    Product.prototype = _.assignIn({}, Product.prototype, {
        _stringOverrides: function() {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },
        _initBreakpoints: function() {
            var self = this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function() {
                    if ($(self.selectors.productThumbImages).length > 3) {
                        self._initThumbnailSlider();
                    }
                    if (self.settings.zoomEnabled) {
                        $(self.selectors.productImageWraps).each(function() {
                            _destroyZoom(this);
                        });
                    }
                    self.settings.bpSmall = true;
                },
                unmatch: function() {
                    if (self.settings.sliderActive) {
                        self._destroyThumbnailSlider();
                    }
                    self.settings.bpSmall = false;
                }
            });
            enquire.register(this.settings.mediaQueryMediumUp, {
                match: function() {
                    if (self.settings.zoomEnabled) {
                        $(self.selectors.productImageWraps).each(function() {
                            _enableZoom(this);
                        });
                    }
                }
            });
        },
        _initVariants: function() {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };
            this.variants = new slate.Variants(options);
            this.$container.on('variantChange' + this.settings.namespace, this._updateAvailability.bind(this));
            this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
            this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
            this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
        },
        _initImageSwitch: function() {
            if (!$(this.selectors.productThumbImages).length) {
                return;
            }
            var self = this;
            $(this.selectors.productThumbImages).on('click', function(evt) {
                evt.preventDefault();
                var $el = $(this);
                var imageId = $el.data('thumbnail-id');
                self._switchImage(imageId);
                self._setActiveThumbnail(imageId);
            }).on('keyup', self._handleImageFocus.bind(self));
        },
        _initAddToCart: function() {
            $(this.selectors.productForm, this.$container).on('submit', function(evt) {
                if (this.$addToCart.is('[aria-disabled]')) {
                    evt.preventDefault();
                    return;
                }
                if (!this.ajaxEnabled)
                    return;
                evt.preventDefault();
                this.$previouslyFocusedElement = $(':focus');
                var isInvalidQuantity = this.$quantityInput.val() <= 0;
                if (isInvalidQuantity) {
                    this._showErrorMessage(theme.strings.quantityMinimumMessage);
                    return;
                }
                if (!isInvalidQuantity && this.ajaxEnabled) {
                    this._handleButtonLoadingState(true);
                    var $data = $(this.selectors.productForm, this.$container);
                    this._addItemToCart($data);
                    return;
                }
            }
            .bind(this));
        },
        _addItemToCart: function(data) {
          var _this = this;
            var params = {
                url: '/cart/add.js',
                data: $(data).serialize(),
                dataType: 'json'
            };
            $.post(params).done(function(item) {
                _this._hideErrorMessage();
                _this._handleButtonLoadingState(false);
                // Envision - disable cart popup when replacement cart drawer is enabled
                if (typeof window.SETTINGS !== 'undefined' && typeof window.SETTINGS.ENABLE_CART_DRAWER !== 'undefined') {
                  if (window.SETTINGS.ENABLE_CART_DRAWER == false) {
                    _this._setupCartPopup(item);
                  }
                } else {
                  // this._setupCartPopup(item);
                }
            }
            .bind(this)).fail(function(response) {
                this.$previouslyFocusedElement.focus();
                var errorMessage = response.responseJSON ? response.responseJSON.description : theme.strings.cartError;
                this._showErrorMessage(errorMessage);
                this._handleButtonLoadingState(false);
            }
            .bind(this));
        },
        _handleButtonLoadingState: function(isLoading) {
            if (isLoading) {
                this.$addToCart.attr('aria-disabled', true);
                // this.$addToCartText.addClass(this.classes.hidden);
                this.$loader.removeClass(this.classes.hidden);
                this.$shopifyPaymentButton.attr('disabled', true);
                this.$loaderStatus.attr('aria-hidden', false);
            } else {
                this.$addToCart.removeAttr('aria-disabled');
                this.$addToCartText.removeClass(this.classes.hidden);
                this.$loader.addClass(this.classes.hidden);
                this.$shopifyPaymentButton.removeAttr('disabled');
                this.$loaderStatus.attr('aria-hidden', true);
            }
        },
        _showErrorMessage: function(errorMessage) {
            $(this.selectors.errorMessage, this.$container).html(errorMessage);
            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.addClass(this.classes.inputError);
            }
            this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr('aria-hidden', true).removeAttr('aria-hidden');
        },
        _hideErrorMessage: function() {
            this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden);
            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.removeClass(this.classes.inputError);
            }
        },
        _setupCartPopup: function(item) {
            this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
            this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
            this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
            this.$cartPopupProperty = this.$cartPopupProperty || $(this.selectors.cartPopupProperty), 
            this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
            this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
            this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose);
            this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
            this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder);
            this._setupCartPopupEventListeners();
            this._updateCartPopupContent(item);
        },
        _updateCartPopupContent: function(item) {
//           if(typeof window.BOLD !== 'undefined'

//              && typeof window.BOLD.common !== 'undefined'

//              && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//             // NOTE: "item" should be the variable containing the item json data from the cart/add.js response

//             item = window.BOLD.common.cartDoctor.fixItem(item);
//           }
             var recurring_desc = "";

            if(item.properties_all  && item.properties_all.frequency_num){

              recurring_desc = "<span> Delivered Every " + item.properties_all.frequency_num + " " + item.properties_all.frequency_type_text + " " + item.properties_all.discounted_price + " each" + "</span>"; 

            }
            var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;
            console.log("quantity",quantity);
            this.$cartPopupTitle.text(item.product_title);
            this.$cartPopupProperty.html(recurring_desc),
            this.$cartPopupQuantity.text(quantity);
            this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace('[count]', quantity));
            this._setCartPopupPlaceholder(item.featured_image.url, item.featured_image.aspect_ratio);
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(item.product_has_only_default_variant, item.options_with_values, item.properties);
            $.getJSON('/cart.js').then(function(cart) {
//                if(typeof window.BOLD !== 'undefined'

//                  && typeof window.BOLD.common !== 'undefined'

//                  && typeof window.BOLD.common.cartDoctor !== 'undefined') {

//                 // NOTE: "cart" should be the variable containing the cart json data

//                 cart = window.BOLD.common.cartDoctor.fix(cart);

//               }
                this._setCartQuantity(cart.item_count);
                this._setCartCountBubble(cart.item_count);
                this._showCartPopup();
            }
            .bind(this));
        },
        _setupCartPopupEventListeners: function() {
            this.$cartPopupWrapper.on('keyup', function(event) {
                if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                    this._hideCartPopup(event);
                }
            }
            .bind(this));
            this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
            this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
            $('body').on('click', this._onBodyClick.bind(this));
        },
        _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
            this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);
            if (imageUrl === null) {
                this.$cartPopupImageWrapper.addClass(this.classes.hidden);
                return;
            }
            var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
            var maxWidth = 95 * imageAspectRatio;
            var heightRatio = 100 / imageAspectRatio;
            this.$cartPopupImagePlaceholder.css('max-width', maxWidth);
            $placeholder.css('padding-top', heightRatio + '%');
        },
        _setCartPopupImage: function(imageUrl, imageAlt) {
            if (imageUrl === null)
                return;
            this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
            var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
            var image = document.createElement('img');
            image.src = sizedImageUrl;
            image.alt = imageAlt;
            image.classList.add(this.classes.cartImage);
            image.dataset.cartPopupImage = '';
            image.onload = function() {
                this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
                this.$cartPopupImageWrapper.append(image);
            }
            .bind(this);
        },
        _setCartPopupProductDetails: function(product_has_only_default_variant, options, properties) {
            this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';
            if (!product_has_only_default_variant) {
                variantPropertiesHTML = variantPropertiesHTML + this._getVariantOptionList(options);
            }
            if (properties !== null && Object.keys(properties).length !== 0) {
                variantPropertiesHTML = variantPropertiesHTML + this._getPropertyList(properties);
            }
            if (variantPropertiesHTML.length === 0) {
                this.$cartPopupProductDetails.html('');
                this.$cartPopupProductDetails.attr('hidden', '');
            } else {
                this.$cartPopupProductDetails.html(variantPropertiesHTML);
                this.$cartPopupProductDetails.removeAttr('hidden');
            }
        },
        _getVariantOptionList: function(variantOptions) {
            var variantOptionListHTML = '';
            variantOptions.forEach(function(variantOption) {
                variantOptionListHTML = variantOptionListHTML + '<li class="product-details__item product-details__item--variant-option">' + variantOption.name + ': ' + variantOption.value + '</li>';
            });
            return variantOptionListHTML;
        },
        _getPropertyList: function(properties) {
            var propertyListHTML = '';
            var propertiesArray = Object.entries(properties);
            propertiesArray.forEach(function(property) {
                if (property[0].charAt(0) === '_')
                    return;
                if (property[1].length === 0)
                    return;
                if (property[0].startsWith('Preorder'))
                    propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property" style="color: #a2252ad4">' + property[1] + '</li>';
                else
                  propertyListHTML = propertyListHTML + '<li class="product-details__item product-details__item--property">' + '<span class="product-details__property-label">' + property[0] + ': </span>' + property[1] + '</li>';
            });
            return propertyListHTML;
        },
        _setCartQuantity: function(quantity) {
            this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;
            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }
            this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
        },
        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(this.selectors.cartCount);
            this.$cartCountBubble.removeClass(this.classes.hidden);
            this.$cartCount.text(quantity);
        },
        _showCartPopup: function() {
            this.$cartPopupWrapper.prepareTransition().removeClass(this.classes.cartPopupWrapperHidden);
            this._handleButtonLoadingState(false);
            slate.a11y.trapFocus({
                $container: this.$cartPopupWrapper,
                $elementToFocus: this.$cartPopup,
                namespace: 'cartPopupFocus'
            });
        },
        _hideCartPopup: function(event) {
            var setFocus = event.detail === 0 ? true : false;
            this.$cartPopupWrapper.prepareTransition().addClass(this.classes.cartPopupWrapperHidden);
            $(this.selectors.cartPopupImage).remove();
            this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);
            slate.a11y.removeTrapFocus({
                $container: this.$cartPopupWrapper,
                namespace: 'cartPopupFocus'
            });
            if (setFocus)
                this.$previouslyFocusedElement[0].focus();
            this.$cartPopupWrapper.off('keyup');
            this.$cartPopupClose.off('click');
            this.$cartPopupDismiss.off('click');
            $('body').off('click');
        },
        _onBodyClick: function(event) {
            var $target = $(event.target);
            if ($target[0] !== this.$cartPopupWrapper[0] && !$target.parents(this.selectors.cartPopup).length) {
                this._hideCartPopup(event);
            }
        },
        _setActiveThumbnail: function(imageId) {
         
            if (typeof imageId === 'undefined') {
                imageId = $(this.selectors.productImageWraps + ':not(.hide)', this.$container).data('image-id');
            }
            var $thumbnailWrappers = $(this.selectors.productThumbListItem + ':not(.slick-cloned)', this.$container);
            var $activeThumbnail = $thumbnailWrappers.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + imageId + "']");
            $(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr('aria-current');
            $activeThumbnail.addClass(this.classes.activeClass);
            $activeThumbnail.attr('aria-current', true);
            if (!$thumbnailWrappers.hasClass('slick-slide')) {
                return;
             
            }
            var slideIndex = $activeThumbnail.parent().data('slick-index');
            $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
        },
        _switchImage: function(imageId) {
            var $newImage = $(this.selectors.productImageWraps + "[data-image-id='" + imageId + "']", this.$container);
            var $otherImages = $(this.selectors.productImageWraps + ":not([data-image-id='" + imageId + "'])", this.$container);
            //$newImage.removeClass(this.classes.hidden);
            //$otherImages.addClass(this.classes.hidden);
        },
        _handleImageFocus: function(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.ENTER)
                return;
            $(this.selectors.productFeaturedImage + ':visible').focus();
        },
        _initThumbnailSlider: function() {
            var options = {
                slidesToShow: 4,
                slidesToScroll: 3,
                infinite: false,
                prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
                nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
                responsive: [{
                    breakpoint: 321,
                    settings: {
                        slidesToShow: 3
                    }
                }]
            };
            $(this.selectors.productThumbs).slick(options);
            $(this.selectors.productThumbsWrapper, this.$container).find('.slick-list').removeAttr('aria-live');
            $(this.selectors.productThumbsWrapper, this.$container).find('.slick-disabled').removeAttr('aria-disabled');
            this.settings.sliderActive = true;
        },
        _destroyThumbnailSlider: function() {
            $(this.selectors.productThumbs).slick('unslick');
            this.settings.sliderActive = false;
            $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr('tabindex');
        },
        _liveRegionText: function(variant) {
            var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';
            if (!variant) {
                liveRegionText = theme.strings.unavailable;
                return liveRegionText;
            }
            var availability = variant.available ? '' : theme.strings.soldOut + ',';
            liveRegionText = liveRegionText.replace('[Availability]', availability);
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            var saleLabel = '';
            var salePrice = '';
            var unitLabel = '';
            var unitPrice = '';
            if (variant.compare_at_price > variant.price) {
                regularLabel = theme.strings.regularPrice;
                regularPrice = theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat) + ',';
                saleLabel = theme.strings.sale;
                salePrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
            }
            if (variant.unit_price) {
                unitLabel = theme.strings.unitPrice;
                unitPrice = theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) + ' ' + theme.strings.unitPriceSeparator + ' ' + this._getBaseUnit(variant);
            }
            liveRegionText = liveRegionText.replace('[Regular]', regularLabel).replace('[$$]', regularPrice).replace('[Sale]', saleLabel).replace('[$]', salePrice).replace('[UnitPrice]', unitLabel).replace('[$$$]', unitPrice).trim();
            return liveRegionText;
        },
        _updateLiveRegion: function(evt) {
            var variant = evt.variant;
            var liveRegion = this.container.querySelector(this.selectors.productStatus);
            liveRegion.innerHTML = this._liveRegionText(variant);
            liveRegion.setAttribute('aria-hidden', false);
            setTimeout(function() {
                liveRegion.setAttribute('aria-hidden', true);
            }, 1000);
        },
        _updateAddToCart: function(evt) {
            var variant = evt.variant;
            let preorderMessageElement = this.$addToCart.next('.preorder_message');
            let preorderPropertyInput = this.$container.find('input[name="properties[Preorder]"]');
            if (variant) {
                if (variant.available) {
                    let ATCText = theme.strings.addToCart;
                    let preorderMessage = theme.strings.preorderMessage;
                    if (this.productSingleObject.tags.indexOf('pre-order') > -1 && variant.inventory_quantity <= 0 && variant.inventory_policy == 'continue') {
                        ATCText = "Pre-Order";
                        if (variant.metafields?.preordermsg.preordermsg) {
                            preorderMessage = variant.metafields.preordermsg.preordermsg;
                        }
                        if (!preorderMessageElement.length) {
                            this.$addToCart.after('<div class="preorder_message">' + preorderMessage + '</div>');
                        } else {
                            preorderMessageElement.show();
                        }
                        preorderPropertyInput.prop('disabled', false);
                    } else {
                        if (preorderMessageElement.length) {
                            preorderMessageElement.hide();
                        }
                        preorderPropertyInput.prop('disabled', true);
                    }
                    this.$addToCart.removeAttr('aria-disabled').attr('aria-label', ATCText);
                    $(this.selectors.addToCartText, this.$container).text(ATCText);
                    this.$shopifyPaymentButton.show();
                } else {
                    this.$addToCart.attr('aria-disabled', true).attr('aria-label', theme.strings.soldOut);
                    $(this.selectors.addToCartText, this.$container).text(theme.strings.soldOut);
                    this.$shopifyPaymentButton.hide();
                    if (preorderMessageElement.length) {
                        preorderMessageElement.hide();
                    }
                    preorderPropertyInput.prop('disabled', true);
                }
            } else {
                this.$addToCart.attr('aria-disabled', true).attr('aria-label', theme.strings.unavailable);
                $(this.selectors.addToCartText, this.$container).text(theme.strings.unavailable);
                this.$shopifyPaymentButton.hide();
                preorderPropertyInput.prop('disabled', true);
            }
        },
        _updateAvailability: function(evt) {
            this._hideErrorMessage();
            this._updateAddToCart(evt);
            this._updateLiveRegion(evt);
            this._updatePrice(evt);
        },
        _updateImages: function(evt) {
            var variant = evt.variant;
            var imageId = variant.featured_image.id;
            this._switchImage(imageId);
            this._setActiveThumbnail(imageId);
        },
        _updatePrice: function(evt) {
            var variant = evt.variant;
            var $priceContainer = $(this.selectors.priceContainer, this.$container);
            var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
            var $salePrice = $(this.selectors.salePrice, $priceContainer);
            var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
            var $unitPriceBaseUnit = $(this.selectors.unitPriceBaseUnit, $priceContainer);
            $priceContainer.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeClass(this.classes.productUnitAvailable).removeClass(this.classes.productSoldOut).removeAttr('aria-hidden');
            this.$productPolicies.removeClass(this.classes.visibilityHidden);
//             if (!variant) {
//                 $priceContainer.addClass(this.classes.productUnavailable).attr('aria-hidden', true);
//                 this.$productPolicies.addClass(this.classes.visibilityHidden);
//                 return;
//             }
//             if (!variant.available) {
//                 $priceContainer.addClass(this.classes.productSoldOut);
//                 return;
//             }
            if (variant.compare_at_price > variant.price) {
//               console.log("if compare price- "+variant.compare_at_price);
//               console.log("if variant price- "+variant.price);
              
                $regularPrice.html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
                $salePrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
                $priceContainer.addClass(this.classes.productOnSale);
            } else {
//               console.log("ELSE compare price- "+variant.compare_at_price);
//               console.log("ELSE variant price- "+variant.price);
                $regularPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
            }
            if (variant.unit_price) {
                $unitPrice.html(theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat));
                $unitPriceBaseUnit.html(this._getBaseUnit(variant));
                $priceContainer.addClass(this.classes.productUnitAvailable);
            }
        },
        _getBaseUnit: function(variant) {
            return variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
        },
        _updateSKU: function(evt) {
            var variant = evt.variant;
            $(this.selectors.SKU).html(variant.sku);
        },
        onUnload: function() {
            this.$container.off(this.settings.namespace);
        }
    });
    function _enableZoom(el) {
        var zoomUrl = $(el).data('zoom');
        $(el).zoom({
            url: zoomUrl
        });
    }
    function _destroyZoom(el) {
        $(el).trigger('zoom.destroy');
    }
    return Product;
}
)();
theme.ProductRecommendations = (function() {
    function ProductRecommendations(container) {
        this.$container = $(container);
        var baseUrl = this.$container.data('baseUrl');
        var productId = this.$container.data('productId');
        var recommendationsSectionUrl = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=8';
        $.get(recommendationsSectionUrl).then(function(section) {
          console.log($(section).html());
            var recommendationsMarkup = $(section).html();
            if (recommendationsMarkup.trim() !== '') {
                this.$container.html(recommendationsMarkup);
            }
        }
        .bind(this));
    }
    return ProductRecommendations;
}
)();
theme.ProductRecommendationsDrawer = (function() {
    function ProductRecommendations(container) {
        this.$container = $(container);
        var baseUrl = this.$container.data('baseUrl');
        var productId = this.$container.data('productId');
        var recommendationsSectionUrl = baseUrl + '?section_id=product-recommendation-drawer&product_id=' + productId + '&limit=2';
        $.get(recommendationsSectionUrl).then(function(section) {
          console.log($(section).html());
            var recommendationsMarkup = $(section).html();
            if (recommendationsMarkup.trim() !== '') {
                this.$container.html(recommendationsMarkup);
            }
        }
        .bind(this));
    }
    return ProductRecommendations;
}
)();
theme.Quotes = (function() {
    var config = {
        mediaQuerySmall: 'screen and (max-width: 749px)',
        mediaQueryMediumUp: 'screen and (min-width: 750px)',
        slideCount: 0
    };
    var defaults = {
        accessibility: true,
        arrows: true,
        dots: false,
        autoplay: false,
        touchThreshold: 20,
        slidesToShow: 3,
        slidesToScroll: 3
    };
    function Quotes(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var wrapper = (this.wrapper = '.quotes-wrapper');
        var slider = (this.slider = '#Quotes-' + sectionId);
        var $slider = $(slider, wrapper);
        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
        });
        config.slideCount = $slider.data('count');
        if (config.slideCount < defaults.slidesToShow) {
            defaults.slidesToShow = config.slideCount;
            defaults.slidesToScroll = config.slideCount;
        }
        $slider.on('init', this.a11y.bind(this));
        enquire.register(config.mediaQuerySmall, {
            match: function() {
                initSlider($slider, mobileOptions);
            }
        });
        enquire.register(config.mediaQueryMediumUp, {
            match: function() {
                initSlider($slider, defaults);
            }
        });
        function initSlider(sliderObj, args) {
            if (sliderActive) {
                sliderObj.slick('unslick');
                sliderActive = false;
            }
            sliderObj.slick(args);
            sliderActive = true;
        }
    }
    Quotes.prototype = _.assignIn({}, Quotes.prototype, {
        onUnload: function() {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);
            $(this.slider, this.wrapper).slick('unslick');
        },
        onBlockSelect: function(evt) {
            var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
            var slideIndex = $slide.data('slick-index');
            $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
        },
        a11y: function(event, obj) {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);
            $list.removeAttr('aria-live');
            $wrapper.on('focusin', function(evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.attr('aria-live', 'polite');
                }
            });
            $wrapper.on('focusout', function(evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });
    return Quotes;
}
)();
theme.slideshows = {};
theme.SlideshowSection = (function() {
    function SlideshowSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slideshow = (this.slideshow = '#Slideshow-' + sectionId);
        theme.slideshows[slideshow] = new theme.Slideshow(slideshow,sectionId);
    }
    return SlideshowSection;
}
)();
theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
    onUnload: function() {
        delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
        var adaptHeight = $slideshow.data('adapt-height');
        if (adaptHeight) {
            theme.slideshows[this.slideshow].setSlideshowHeight();
        }
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },
    onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
    }
});
theme.slideshows = {};
theme.VideoSection = (function() {
    function VideoSection(container) {
        var $container = (this.$container = $(container));
        $('.video', $container).each(function() {
            var $el = $(this);
            theme.Video.init($el);
            theme.Video.editorLoadVideo($el.attr('id'));
        });
    }
    return VideoSection;
}
)();
theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
    onUnload: function() {
        theme.Video.removeEvents();
    }
});
theme.heros = {};
theme.HeroSection = (function() {
    function HeroSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var hero = '#Hero-' + sectionId;
        theme.heros[hero] = new theme.Hero(hero,sectionId);
    }
    return HeroSection;
}
)();
$(document).ready(function() {
    var sections = new theme.Sections();
    sections.register('cart-template', theme.Cart);
    sections.register('product', theme.Product);
    sections.register('collection-template', theme.Filters);
    sections.register('product-template', theme.Product);
    sections.register('header-section', theme.HeaderSection);
    sections.register('map', theme.Maps);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('quotes', theme.Quotes);
    sections.register('hero-section', theme.HeroSection);
    sections.register('product-recommendations', theme.ProductRecommendations);
    sections.register('product-recommendations-drawer', theme.ProductRecommendationsDrawer);
  
});
theme.init = function() {
    theme.customerTemplates.init();
    var tableSelectors = '.rte table,' + '.custom__item-inner--html table';
    slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'scrollable-wrapper'
    });
    var iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"],' + '.custom__item-inner--html iframe[src*="youtube.com/embed"],' + '.custom__item-inner--html iframe[src*="player.vimeo"]';
    slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'video-wrapper'
    });
    slate.a11y.pageLinkFocus($(window.location.hash));
    $('.in-page-link').on('click', function(evt) {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });
    $('a[href="#"]').on('click', function(evt) {
        evt.preventDefault();
    });
    slate.a11y.accessibleLinks({
        messages: {
            newWindow: theme.strings.newWindow,
            external: theme.strings.external,
            newWindowExternal: theme.strings.newWindowExternal
        },
        $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
    });
    theme.FormStatus.init();
    var selectors = {
        image: '[data-image]',
        imagePlaceholder: '[data-image-placeholder]',
        imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]',
        lazyloaded: '.lazyloaded'
    };
    var classes = {
        hidden: 'hide'
    };
    $(document).on('lazyloaded', function(e) {
        var $target = $(e.target);
        if ($target.data('bgset')) {
            var $image = $target.find(selectors.lazyloaded);
            if ($image) {
                if ($target.data('bg')) {
                    $image.attr('src', $target.data('bg'));
                }
                if ($target.data('alt')) {
                    $image.attr('alt', $target.data('alt'));
                }
            }
        }
        if (!$target.is(selectors.image)) {
            return;
        }
        $target.closest(selectors.imageWithPlaceholderWrapper).find(selectors.imagePlaceholder).addClass(classes.hidden);
    });
    function onLoadHideLazysizesAnimation() {
        $(selectors.image + '.lazyloaded').closest(selectors.imageWithPlaceholderWrapper).find(selectors.imagePlaceholder).addClass(classes.hidden);
    }
    onLoadHideLazysizesAnimation();
}
;
$(theme.init);
$(window).scroll(function() {
    var scroll = $(window).scrollTop();
    var announcment = $('.announcement-bar');
    if (announcment.length == 0) {
        $('.site-header').addClass('fixed-header');
    } else {
        if (scroll <= 44) {
            $('.site-header').removeClass('fixed-header');
            $('.announcement-bar').css('opacity', '1')
        } else if (scroll >= 45) {
            $('.site-header').addClass('fixed-header');
            $('.announcement-bar').css('opacity', '0')
        }
        if ($(window).width() < 767) {
            var height = $('.site-header').outerHeight() - 2;
            if (scroll <= 44) {
                height = height + 44;
                $('.mobile-nav-wrapper.js-menu--is-open').css({
                    transform: 'translateY(' + height + 'px)'
                });
            } else if (scroll >= 45) {
                $('.mobile-nav-wrapper.js-menu--is-open').css({
                    transform: 'translateY(' + height + 'px)'
                });
            }
        }
    }
});
$(document).ready(function() {
    var com_price = '999999999999999999999999999';
    $.get("https://api.ipdata.co?api-key=test", function(response) {
        console.log(JSON.stringify(response, null, 4));
        var country = response.country_name;
        var sub_total = $('.free_shipping').attr('sub_t');
        console.log('country: ' + country);
        if (country == 'Canada') {
            com_price = '4399';
            if (sub_total > 19999) {
                $('.free_shipping').css('display', 'block');
            } else {
                $('.free_shipping').css('display', 'none');
            }
        } else if (country == 'United States') {
            com_price = '19999';
            if (sub_total > 4400) {
                $('.free_shipping').css('display', 'block');
            } else {
                $('.free_shipping').css('display', 'none');
            }
        } else {
            $('.free_shipping').css('display', 'none');
        }
    });
  
  $('#quantity_button span').click(function(e){
		e.preventDefault();
    var quantity_input = $('input#Quantity-product-template');
		var _this = $(this);
		if(_this.hasClass('plus')){
			quantity_input.val(parseInt(quantity_input.val()) + 1)
		}else if(_this.hasClass('minus')){
			if(parseInt(quantity_input.val()) !== 1){
				quantity_input.val(parseInt(quantity_input.val()) - 1)
			}
		}
	});

  $(document).click(function(event) {
    let target = $(event.target);
    //console.log(target);
    if((target.hasClass('add-to-cart-image-modal')) || (target.hasClass('medium-up--hide')) || (target.hasClass('small--hide')) || (target.hasClass('down_arrow')) || (target.hasClass('fa-angle-down')) || (target.hasClass('full-cart-text')) || (target.hasClass('compare-wrap'))){
    }else if(target.hasClass('select')){
    } else{
      $('.overlay-product-options').addClass('hidden');
      $(".overlay-product-options").find("li").attr("tabindex", "-1");
      $('ul.vatiant_options').hide();
      console.log('close button');
    }
  });

  $('div#variant-name span.select').click(function(){
    
    $(this).next('ul.vatiant_options').show();
    
  });
  
  $('ul.vatiant_options li').click(function(){
    
    var vall = $(this).attr('data-url');
  
    if ($(this).data('soldout-text')) {
  		var soldout_text = $(this).attr('data-soldout-text');
    }
    
        
    $('ul.vatiant_options li').removeClass('active');
    
    $(this).addClass('active');
    
    
    $("select#SingleOptionSelector-0 option").each(function(){
    
      if($(this).val() == vall){
      
//         console.log($(this).val()+" ===> this val");
//         console.log(vall +" ===> VALL");
                  
        var optionValue = $(this).val();
        $("select#SingleOptionSelector-0").val(optionValue)
      .trigger('change');
      }
    });
    
    if($('button.btn.product-form__cart-submit.addtocart.cartbutton').attr('aria-label') == 'In Stock Soon'){
      
      $('.klaviyo-bis-trigger').show();
    }else{
      $('.klaviyo-bis-trigger').hide();
    }
    
    $('ul.vatiant_options').hide(200);
   
    if (soldout_text) {
      $('div#variant-name span.select').text(vall+" "+soldout_text);
      
    }else{
	  $('div#variant-name span.select').text(vall);
    }
                    
  });
  
  //for variant buttun JS
  $('.variant-btn .varint-lbl label').click(function(){
  	var vall = $(this).attr('data-url');
    $("select#SingleOptionSelector-0 option").each(function(){
      if($(this).val() == vall){
        var optionValue = $(this).val();
        $("select#SingleOptionSelector-0").val(optionValue)
        .trigger('change');
      }
    });
    if($('button.btn.product-form__cart-submit.addtocart.cartbutton').attr('aria-label') == 'In Stock Soon'){

      $('.klaviyo-bis-trigger').show();
    }else{
      $('.klaviyo-bis-trigger').hide();
    }
  });
  //end variant buttun JS
  
});

$('.single-option-selector-product-template').on('change', function() {

    var val = this.value;

    $('select#ProductSelect-product-template option').each(function() {

        if (val == this.value) {

            var attr = $(this).attr('disabled');

            var price = $(this).attr('data-price');

            if (typeof attr !== typeof undefined && attr !== false) {

                $('.price__availability span.price-item.price-item--sale').text(price);

            }

        }

    });

});

$(document).ready(function(){
  
//   var option = $("select#SingleOptionSelector-0").data('urlcheck');
  var option = $("select#SingleOptionSelector-0").attr('data-urlcheck');
  console.log(option);
  
  $('div#variant-name span.select').text(option);
});


$('.inner-links a').on( 'click', function(event) {
	var target 	= jQuery( this );
    var element = target.attr('href');

    jQuery('.inner-links a').removeClass('active')
    target.addClass('active');

    jQuery("body, html").animate({ 
      scrollTop: jQuery( element ).offset().top - 90	
    }, 800);

});


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

$(document).ready(function(){

  if($("body").hasClass("template-product") && $(".product-form .addtocart").length > 0){
    $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    var objectSelect = $(".product-form .addtocart");
    var objectPosition = objectSelect.offset().top;
    if (scroll > objectPosition) {
		  $(".add_cart_btn_fix").addClass("active");
    } else {
      	  $(".add_cart_btn_fix").removeClass("active");
	      }
	});
  }


  $(".add_cart_btn_fix .sticky-add-to-cart").on("click",function(){
     $("form.product-form .addtocart").trigger("click");
  }); 
  
 

});


if($(window).width() < 750 ){

  // $(".gallery-mob-slider").slick({
  //   dots: true,
  //   centerPadding: '70px',
  //   arrows: false,
  //   infinite: false,
  //   adaptiveHeight: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   centerMode: true,
  //   initialSlide: 0
  // });
  // $('.gallery-mob-slider').slick('slickUnfilter');
  // $('.gallery-mob-slider').slick('slickFilter','.show');

  //if(!$('body').hasClass('template-article')){
  if(!$('body').hasClass('template-product')){
    $('.multiple-product-items').slick({
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: false,
      arrows: false,
      slidesToScroll: 1,
      dots: true,
      centerPadding: '70px',
      centerMode: true
    });
  }

  $('#shopify-section-1594682591718 .multiple-coloum-items,#shopify-section-1602103116296 .multiple-coloum-items').slick({
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    slidesToScroll: 1,
    dots: true
  });

}

$('.gallery-mob-slider')
.clone()
.insertAfter('.gallery-mob-slider')
.addClass('gallery-mob-slider-nav')
.removeClass('gallery-mob-slider')
.find('.pdp-video-play-button')
.replaceWith('<div class="pdp-video-play-button-disabled"><span></span></div>');

$('.gallery-mob-slider').slick({
    asNavFor: '.gallery-mob-slider-nav',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    focusOnSelect: true,
    arrows: false
});
$('.gallery-mob-slider').slick('slickUnfilter');
$('.gallery-mob-slider').slick('slickFilter','.show');
$(".gallery-mob-slider .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
});
    
const galleryMobSliderNav = $('.gallery-mob-slider-nav');
const galleryMobSliderNavNumberOfSlides = galleryMobSliderNav.find(".product-single__photo-wrapper.js.show").length;

galleryMobSliderNav.slick({
    asNavFor: '.gallery-mob-slider',
    infinite: galleryMobSliderNavNumberOfSlides > 5 ? true : false,
    speed: 300,
    slidesToShow: 5.5,
    slidesToScroll: galleryMobSliderNavNumberOfSlides > 5 ? 1 : galleryMobSliderNavNumberOfSlides,
    adaptiveHeight: false,
    focusOnSelect: true,
    arrows: false
});

if (galleryMobSliderNavNumberOfSlides > 5) {
    galleryMobSliderNav.find('.slick-track').css('margin-left', '-10%');
} else {
    galleryMobSliderNav.slick('slickSetOption', 'infinite', false, true);
}

$('.gallery-mob-slider-nav').prepend('<button class="slick-prev slick-arrow" aria-label="Previous" type="button">Previous</button>');
$('.gallery-mob-slider-nav').append('<button class="slick-next slick-arrow" aria-label="Next" type="button">Next</button>');
$('.gallery-mob-slider-nav .slick-prev').on('click', function () {
    $('.gallery-mob-slider').slick('slickPrev');
});
$('.gallery-mob-slider-nav .slick-next').on('click', function () {
    $('.gallery-mob-slider').slick('slickNext');
});

$('.gallery-mob-slider-nav').slick('slickUnfilter');
$('.gallery-mob-slider-nav').slick('slickFilter','.show');
$(".gallery-mob-slider-nav .slick-slide:not(.slick-cloned)").each(function (index, slide) {
    $(slide).attr("data-slick-index", index);
});

$('.gallery-mob-slider').slick('slickSetOption', 'responsive', [
    {
        breakpoint: 750,
        settings: {
            centerMode: true,
            centerPadding: "20%"
        }
    } 
], true);

function getDetails(url) {
    return fetch(url).then(response => response.json());
}

var u = "https://get.geojs.io/v1/ip/country.json";
	getDetails(u).then(function(data) {
    console.log(data.country);
  
	if(data.country == "US"){
      $(".ann_us_show").removeClass("hidden");
      $(".ann_us_show").addClass("active_ann");
      $(".close_btn").removeClass("hidden");
    }else if(data.country == "CA"){
      $(".ann_cad_show").removeClass("hidden");
      $(".ann_cad_show").addClass("active_ann");
      $(".close_btn").removeClass("hidden");
      $(".spice-up-the-holidays__badge").filter(
        (i, elm) => parseInt($(elm).data('price')) <= 60
      ).hide();
    }else{
      $(".ann_other_show").removeClass("hidden");
      $(".ann_other_show").addClass("active_ann");
      $(".close_btn").removeClass("hidden");
      $(".spice-up-the-holidays__badge").hide();
    }
})
    
$(".close_btn").on("click",function(){
$(this).parents(".top_announcement").hide();
});

// $(".cart-note__label").on("click",function(){
//   $(this).next(".cart-note__input").toggleClass("active");
//   $(this).toggleClass("active");
// });

$(window).scroll(function(){
  var headerHeight = $('.bundle-builder-app--products--block').height();
   var scrollDistance = $(window).scrollTop();
  if($(window).scrollTop() >= 265 && $(window).scrollTop() <= headerHeight ){
    
  $('body').addClass('fixed');
  }
  
 if ($(".add_cart_btn_fix").hasClass("active")) {
    $('body').addClass('fix_cart_btn');
  }else{
   $('body').removeClass('fix_cart_btn');
  }
  
});

$(document).ready(function() {
  var link = $(location).attr("href");
  console.log(link);
  var chk_link = link.includes("https://www.burlapandbarrel.com/apps/bundles");
  if( chk_link == true ){
    $('body').addClass('bundle-builder-app');
  }
  
  console.log($('.free_shipping').attr('sub_t'));
  
   
  
});


$(".acc_btn").on('click' , function(){
  if ($(".acc_btn").hasClass("active")) {
   $(".mobile_acc_btn").find('i').removeClass('fa fa-angle-up').addClass('fa fa-angle-down');
  $('.acc_btn').removeClass('active');
   $(".col_images").css({ 'display' : 'none' });
  }
  
  else{
    $('.acc_btn').addClass('active');
    $(".mobile_acc_btn").find('i').removeClass('fa fa-angle-down').addClass('fa fa-angle-up');
    $(".col_images").css({ 'display' : 'block' });
  }
});

$('.scrolldd').click(function(e){
  e.preventDefault();
  var headerHeight = $('header').height();
  var scroldd = $(this).attr('data-scroll-id');
  $('html, body').animate({
    scrollTop: $("#"+scroldd).offset().top - headerHeight - 50
  }, 1000);
  
});
var data_pos = [];
$( "#Collection .divcp" ).each(function() {
     console.log($(this).offset().top);
     data_pos.push($(this).offset().top);
  });

$(window).scroll(function() {
  var scroll_pos = $(window).scrollTop();
  var closest1 = 0;

  data_pos.forEach(function (item, index) {
    if(closest1 < 1){
      if(Math.abs(item - 10) < Math.abs(scroll_pos)){
        closest1 = 1;
      }
    } else {
      if(Math.abs(item - 100) < Math.abs(scroll_pos)){
        closest1 = index+1;
      } 
    }
  });
  
  if(closest1 > 0){
    $('body').addClass('fixbar');
    $('.back_top_arrow').addClass('show');
  } else{
    $('body').removeClass('fixbar');
    $('.back_top_arrow').removeClass('show');
  }
  
  $('.main_fix_title').removeClass('active');
  $('#div'+closest1).find('.main_fix_title').addClass('active');
});


var btn = $('.back_top_arrow');
btn.on('click', function(e) {
  e.preventDefault();
  var category = $('.coll_start').offset().top;
  $('html, body').animate({scrollTop:category- 100}, '400');
});

// Envision - collection component expandable products
$(function() {
  if ($('.collection-component--container .collection-component--showmore-button').length) {
    $('.collection-component--container .collection-component--showmore-button').on('click', function(e) {
      e.preventDefault();
      var collectionComponent = $(this).parents('.collection-component--container');
      var additionalItems = $('.collection-component--hidden-item', collectionComponent);
      
      if (additionalItems.length) {
        additionalItems.removeClass('hidden');
        
        $('.collection-component--showmore', collectionComponent).addClass('hidden');
      }
    });
  }
});

$(document).on('click', '.varint-lbl', function() {
    var val = $(this).find('label').attr('data-url');
    var title = $('.product-single__title').text();
    var counter = 0;
    $('.product-single__photos .product-single__photo-wrapper:not(.slick-cloned)').each(function() {
        if($(this).find('img').attr('alt') == val) {
            counter++;
        }
    });
    if (counter > 0) {
        $('.product-single__photos .product-single__photo-wrapper:not(.slick-cloned)').each(function() {
            $(this).addClass('hide').removeClass('show');
        });
        $('.product-single__photos .product-single__photo-wrapper:not(.slick-cloned)').each(function() {
            $(this).find('img[alt="' + val + '"]').closest('.product-single__photo-wrapper:not(.slick-cloned)').removeClass('hide').addClass('show');
            $(this).find('img[alt="' + title + '"]').closest('.product-single__photo-wrapper:not(.slick-cloned)').removeClass('hide').addClass('show');
            //if($(window).width() < 768 ){
            $('.gallery-mob-slider').slick('slickUnfilter');
            $('.gallery-mob-slider').slick('slickFilter','.show');
            $(".gallery-mob-slider .slick-slide:not(.slick-cloned)").each(function (index, slide) {
                $(slide).attr("data-slick-index", index);
            });
            $('.gallery-mob-slider-nav').slick('slickUnfilter');
            $('.gallery-mob-slider-nav').slick('slickFilter','.show');
            $(".gallery-mob-slider-nav .slick-slide:not(.slick-cloned)").each(function (index, slide) {
                $(slide).attr("data-slick-index", index);
            });
            //}
        });
        /*
        $('.thumbnails-wrapper .product-single__thumbnails li.product-single__thumbnails-item').each(function(){
          if($(this).attr('alt') == val){
            $(this).removeClass('hide').addClass('show');
          }
          if($(this).attr('alt') == title){
            $(this).removeClass('hide').addClass('show');
          }
        });
        */
    } else {
        $('.product-single__photos .product-single__photo-wrapper:not(.slick-cloned)').each(function(){
            $(this).removeClass('hide').addClass('show');
            //if($(window).width() < 768 ){
            $('.gallery-mob-slider').slick('slickUnfilter');
            $(".gallery-mob-slider .slick-slide:not(.slick-cloned)").each(function (index, slide) {
                $(slide).attr("data-slick-index", index);
            });
            $('.gallery-mob-slider-nav').slick('slickUnfilter');
            $(".gallery-mob-slider-nav .slick-slide:not(.slick-cloned)").each(function (index, slide) {
                $(slide).attr("data-slick-index", index);
            });
            //}
        });
    }
});


$('.product-form__cart-submit, .cart-btn').on('click',function(){
  $(".cart-popup-wrapper").removeClass("cart-hidden");
    setTimeout(function() {
      $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
    }, 4000); 
  });

 $(window).scroll(function() {
  if(!$(".cart-popup-wrapper").hasClass("cart-popup-wrapper--hidden")){
  $(".cart-popup-wrapper").addClass("cart-hidden");
  }
  });
  


jQuery('#notify-me').click(function() {
  jQuery('#notify-me-wrapper').fadeIn();
  return false;
} );

// $(document).on('click','.thumbnails-wrapper .product-single__thumbnails li.product-single__thumbnails-item',function(){
//   if(!$(this).hasClass('no-click')){

//     $('.product-single__photos').removeClass('active'); 
//   }else{
//     $('.product-single__photos').addClass('active'); 
//   }
// });



$('.gallery-mob-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){   
  
    $('.product-single__photos').removeClass('active'); 
    if(currentSlide == 0 )
    { 
      $('.product-single__photos').addClass('active'); 
    }
  
});


$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  var topannounce = $('.top_announcement').height();
  if(scroll > topannounce){
    $('body').addClass('headerfixed');
  } else {
    $('body').removeClass('headerfixed');
  }
});

$('.testimonial_text_slider').slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
  	autoplaySpeed: 4000,
    speed: 500,
    accessibility: false
});


//homepage carousel
function initCarousels() {
  var width = $(window).width();
  console.log(width);
  if(!$('body').hasClass('template-product')){
    if(width > 1500){
        $('.index-section.multiple-product-section .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 100px');
        })
        .slick({ slidesToShow: 4, slidesToScroll: 4 });
    }else if(width >= 1250){
        $('.index-section.multiple-product-section .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 70px');
        })
        .slick({ slidesToShow: 4, slidesToScroll: 4 });
    }else if(width >= 1024){
        $('.index-section.multiple-product-section .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 50px');
        })
        .slick({ slidesToShow: 3, slidesToScroll: 3 });
    }else if(width >= 600){
        $('.index-section.multiple-product-section .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 30px');
        })
        .slick({ slidesToShow: 2, slidesToScroll: 2 });
    }else if(width >= 480){
        $('.index-section.multiple-product-section .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 15px');
        })
        .slick({ slidesToShow: 1, slidesToScroll: 1 });
    }
  
    $('.index-section.multiple-product-section .custom-content.multiple-product-items')
    .each(function() {
      try {
        $(this).slick({
          dots: false,
          infinite: true,
          initialSlide: 2,
          centerMode: true,
          centerPadding: '100px',
          speed: 300,
          adaptiveHeight: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                initialSlide: 1,
                slidesToShow: 4,
                slidesToScroll: 4,
                adaptiveHeight: false,
                centerMode: true,
                centerPadding: '70px'
              }
            },
            {
              breakpoint: 1250,
              settings: {
                initialSlide: 1,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: true,
                adaptiveHeight: false,
                centerPadding: '70px'
              }
            },
            {
              breakpoint: 1024,
              settings: {
                initialSlide: 1,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: '50px'
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: '30px'
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                adaptiveHeight: false,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '20px'
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      } catch(e) {
        console.log(e);
      }
    });
  }
}
$(document).ready(function(){
  initCarousels();
});

// recipe-details page carousel
$(document).ready(function(){

    if (!$('body').hasClass('template-product') && $('body').attr('data-template') == 'article.recipes') {
        const sliderElement = document.querySelector('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items');
        const numberOfSlides = sliderElement.children.length;

        $(sliderElement)
        .slick({
            slidesToShow: numberOfSlides >= 4 ? 4 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 4 ? 4 : numberOfSlides,
            infinite: true,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: numberOfSlides >= 4 ? 4 : numberOfSlides,
                        slidesToScroll: numberOfSlides >= 4 ? 4 : numberOfSlides,
                        infinite: true,
                        dots: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: numberOfSlides >= 4 ? 4 : numberOfSlides,
                        slidesToScroll: numberOfSlides >= 4 ? 4 : numberOfSlides,
                        infinite: true,
                        dots: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: numberOfSlides >= 3 ? 3 : numberOfSlides,
                        slidesToScroll: numberOfSlides >= 3 ? 3 : numberOfSlides,
                        infinite: true,
                        dots: false,
                        centerMode: true,
                        arrows: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: numberOfSlides >= 2 ? 2 : numberOfSlides,
                        slidesToScroll: numberOfSlides >= 2 ? 2 : numberOfSlides,
                        infinite: true,
                        dots: false,
                        arrows: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrows: true,
                        centerMode: numberOfSlides >= 4 ? false : true
                    }
                }
            ]

        });
    }
});

/*
$(document).ready(function(){

  var width = $(window).width();
  console.log(width);

  if (!$('body').hasClass('template-product')) {

    if (width > 1500) {
        $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 100px');
        })
        .slick({ slidesToShow: 4, slidesToScroll: 4 });
    } else if(width >= 1250) {
        $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 70px');
        })
        .slick({ slidesToShow: 4, slidesToScroll: 4 });
    } else if(width >= 1024) {
        $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 50px');
        })
        .slick({ slidesToShow: 3, slidesToScroll: 3 });
    } else if(width >= 600) {
        $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 30px');
        })
        .slick({ slidesToShow: 2, slidesToScroll: 2 });
    } else if(width >= 480) {
        $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
        .on('setPosition', function () {
            $(this).find('.slick-list').css('padding', '0 15px');
        })
        .slick({ slidesToShow: 1, slidesToScroll: 1 });
    }
  
    $('.custom-content-wrapper.blog_recipes .custom-content.multiple-product-items')
    .each(function() {
      try {
        $(this).slick({
          dots: false,
          infinite: true,
          initialSlide: 2,
          centerMode: true,
          centerPadding: '100px',
          speed: 300,
          adaptiveHeight: false,
          slidesToShow: 4,
          //slidesToScroll: 4,
          /*responsive: [
            {
              breakpoint: 1500,
              settings: {
                initialSlide: 1,
                slidesToShow: 4,
                slidesToScroll: 4,
                adaptiveHeight: false,
                centerMode: true,
                centerPadding: '70px'
              }
            },
            {
              breakpoint: 1250,
              settings: {
                initialSlide: 1,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: true,
                adaptiveHeight: false,
                centerPadding: '70px'
              }
            },
            {
              breakpoint: 1024,
              settings: {
                initialSlide: 1,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: '50px'
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                centerPadding: '30px'
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                adaptiveHeight: false,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '80px'
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
      } catch(e) {
        console.log("Slick error:", e);
      }
    });
  
  }

});
*/


// index page video popup
$('.html5lightbox').click(function(){
    $('.index-welcome-custom-sub-btn, .product-single__photo, .masala-card__carousel-item').magnificPopup({
      delegate: 'a',
      type: 'iframe',
      preloader: false,
      mainClass: 'mfp-iframe',
      gallery: {
          enabled: true
      },
      iframe: {
          tError: '<a href="%url%">This video #%curr%</a> could not be loaded.',
          titleSrc: function (item) {
              return '';
          }
      }
    });
});

// $('.index-section.multiple-product-section .custom-content.multiple-product-items').slick({
//   dots: false,
//   infinite: true,
//   initialSlide: 2,
//   centerMode: true,
//   centerPadding: '100px',
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1500,
//       settings: {
//         initialSlide: 1,
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         centerMode: true,
//         centerPadding: '70px'
//       }
//     },
//     {
//       breakpoint: 1250,
//       settings: {
//         initialSlide: 1,
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         centerMode: true,
//         centerPadding: '70px'
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         initialSlide: 1,
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         centerMode: true,
//         centerPadding: '50px'
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         centerMode: true,
//         centerPadding: '30px'
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: true,
//         centerPadding: '20px'
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

// $('.index-section.multiple-product-section .custom-content.multiple-product-items').slick('slickSetOption', 'slidesToScroll', 4, true);

//gift card input box js
// var radio_check = $('.template-product .variant-btn .varint-lbl').find('input[name="id"]:checked').data('title');
// console.log(radio_check);
// if(radio_check == 'Custom Amount'){
//     console.log('match');
//     $('.template-product .line-item-property__field').css('display','block');
//   }

// $('.template-product .variant-btn .varint-lbl').each(function(){
//     $(this).find('label').click(function(){
//       console.log('clicked');
//       var data = $(this).data('url');

//       if(data == 'Custom Amount'){
//         console.log('match');
//         $('.template-product .line-item-property__field').css('display','block');
//       }else{
//         $('.template-product .line-item-property__field').css('display','none');
//       }
//     });
//   });

/*
$(document).ready(function(){
  var width = $(window).width();
  console.log(width);
  var length = $('.blog_recipes .custom-content.multiple-product-items .custom__item').length;
  console.log(length);

  if(width > 1250){
    if(length > 4){
      $('.blog_recipes .custom-content.multiple-product-items').slick({
  dots: false,
  centerMode: false,
  speed: 300,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1250,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        centerPadding: '60px',
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '60px',
         dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    }
  }else if(width >= 1024){
    if(length > 3){
       $('.blog_recipes .custom-content.multiple-product-items').slick({
  dots: false,
  centerMode: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1250,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        centerPadding: '60px',
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '60px',
         dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    }
  }else if(width >= 600){
    if(length > 2){
       $('.blog_recipes .custom-content.multiple-product-items').slick({
  dots: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1250,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        centerPadding: '60px',
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '60px',
         dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    }
  }else if(width >= 200){
    if(length > 1){
       $('.blog_recipes .custom-content.multiple-product-items').slick({
  dots: false,
  infinite: false,
  centerMode: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1250,
      settings: {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        infinite: false,
        centerPadding: '60px',
         dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        adaptiveHeight: true,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '60px',
         dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
    }
  }
  
//  $('.blog_recipes .custom-content.multiple-product-items').slick({
//   dots: false,
//   centerMode: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1500,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 4
//       }
//     },
//     {
//       breakpoint: 1250,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: false,
//         adaptiveHeight: true,
//         slidesToScroll: 1,
//         centerMode: false,
//         infinite: false,
//         centerPadding: '60px',
//          dots: true
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         arrows: false,
//         infinite: false,
//         adaptiveHeight: true,
//         slidesToScroll: 1,
//         centerMode: false,
//         centerPadding: '60px',
//          dots: true
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });
});
*/

/***/

/* Fix the DOM of the PDP review count in order to be able to style it */

const pdpReviewCount = document.querySelector('.product-single__meta .stamped-badge-caption');
if (pdpReviewCount) {
    const [reviewCountFirstChild, reviewCountSecondChild] = pdpReviewCount.childNodes;
    reviewCountSecondChild.prepend(reviewCountFirstChild);
}

/* End fix the DOM of the PDP review count in order to be able to style it */

/***/

/* Add read more/less functionality to the Health Benefits section */

/*

$('.product-single__description .benefits-part-text').each(function () {
    let children = $(this)
    .children()
    .not('.read-more, .read-less')
    .filter(function () {
        return $(this).css('display') !== 'none';
    });
    if (children.length > 1) {
        $(this).append('<a href="#" class="read-more">Read more</a>');
        $(this).append('<a href="#" class="read-less">Read less</a>');
        children.slice(1).hide();
    }
    $(this).find('.read-more').click(function () {
        $(this).hide();
        $(this).siblings().show();
    });
    $(this).find('.read-less').click(function () {
        $(this).hide();
        $(this).siblings().hide();
        $(this).siblings(':first').show();
        $(this).siblings('.read-more').show();
    });
    $(this).find('.read-less').hide();
});

*/

/* End add read more/less functionality to the Health Benefits section */

/***/

/* Add accordion functionality */

const accordions = document.getElementsByClassName("accordion");

[...accordions].forEach(accordion => {
    accordion.addEventListener("click", function() {
        this.classList.toggle("active");
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            const readMore = panel.querySelector('.read-more');
            if (readMore) {
                readMore.click();
                panel.style.maxHeight = panel.scrollHeight + "px";
                panel.querySelector('.read-less').click();
            }
            else
            {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        }
    });
});

/* End add accordion functionality */

/***/

/* Add waitForElm */

function waitForElm(selector, doc = document) {
    return new Promise(resolve => {
        if (doc.querySelector(selector)) {
            return resolve(doc.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (doc.querySelector(selector)) {
                resolve(doc.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(doc, {
            childList: true,
            subtree: true
        });
    });
}

/* End add waitForElm */

/***/

/* Wait for PDP single review, then display the dividers */

/*
** waitForElm(".stamped-reviews-message").then((elm) => {
**     const closestHRs = $(elm).parents("#stamped-reviews-widget").siblings("hr");
**     if (closestHRs) {
**         closestHRs.css("display", "block");
**     }
** });
*/

/* End wait for PDP single review, then display the dividers */

/***/

/*
** Start: Google Captcha badge ADA.
**
** when element with class "grecaptcha-badge" is ready, add "tabindex=0" to it
** and add event listener that shows up its content when space or enter are pressed.
*/

waitForElm(".grecaptcha-badge").then(elm => {
    elm.setAttribute("tabindex", "0");
    elm.addEventListener("keydown", function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            if (elm.style.right === "0px") {
                elm.style.right = "-186px";
            }
            else {
                elm.style.right = "0px";
            }
        }
    });
});

/* End: Google Captcha badge ADA */

/***/

/*
**
** Start making "Questions? Get in touch!" focusable.
**
** - make the iframe "Questions? Get in touch!" focusable by adding "tabindex=0" to its
** parent and adding "tabindex=-1" to the iframe that's inside it, and when the return
** key is pressed click the button element within the iframe.
**
** - when the button element is clicked, wait for the new iframe to load and add the
** the outline styling to the button within it when it's focused.
**
** - hide the button from the Bundle Builder page.
**
*/

waitForElm(".BeaconFabButtonFrame").then(iframeParentDiv => {

    const isBundleBuilder = window.location.href.includes("apps/bundles/bundle");

    if (isBundleBuilder) {

        iframeParentDiv.style.display = "none";

    } else {

        iframeParentDiv.setAttribute("tabindex", "0");
        const iframeElement = iframeParentDiv.querySelector('iframe');
        iframeElement.setAttribute("tabindex", "-1");
        const iframeDocument = iframeElement.contentWindow.document;

        waitForElm('#beacon-container .frame-content button', iframeDocument).then(buttonElm => {

            iframeParentDiv.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    buttonElm.click();
                }
            });

            buttonElm.addEventListener('click', function () {
                /* wait for new iframe to load */
                waitForElm("#beacon-container .hsds-beacon .FabButtonFramecss__FabButtonFrameUI-sc-y1b4md-0.gURcml.BeaconFabButtonFrame").then(newIframeParentDiv => {
                    const newIframeDocument = newIframeParentDiv.querySelector('iframe').contentWindow.document;
                    const newStyleElement = document.createElement("style");
                    newStyleElement.textContent = `#beacon-container .frame-content button:focus { outline: 2px solid #fff !important; outline-offset: -3px !important; outline-style: dotted !important; }`
                    newIframeDocument.head.appendChild(newStyleElement);
                });
            });

        });

    }

});

/* End making "Questions? Get in touch!" focusable */

/***/

/*
**
** Start ADA: Add ability to navigate and select certain widgets:
**
** - Ability to navigate and select a product's variants on a product page using the keyboard.
** - Ability to press the "Add to Cart" button and navigate and select its options using
** the keyboard.
** - Ability to hide the "Add to Cart" options dropdown when navigating back & forth.
**
*/

document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
        if (event.target.classList.contains('varint-lbl')) {
            event.preventDefault();
            event.target.querySelector('input.variant-option').click();
        } else if (event.target.classList.contains('add-to-cart-image-modal') || event.target.tagName === "LI" && event.target.parentElement.parentElement.classList.contains('overlay-product-options')) {
            event.preventDefault();
            event.target.click();
        }
    }
});
$(".overlay-product-options ul li").on('keydown', function (event) {
    if ((event.key === 'Tab' && !event.shiftKey && $(this).is(':last-child')) || (event.key === 'Tab' && event.shiftKey && $(this).is(':first-child'))) {
        const overlayProductOptions = $(this).parents('.overlay-product-options');
        overlayProductOptions.addClass('hidden');
        overlayProductOptions.find("li").attr("tabindex", "-1");
    }
});

/* End ADA: Add ability to navigate and select certain widgets */

/***/

/* Start ADA: When opening the Spice Quiz, the focus should be moved to the Spice Quiz iframe */

const quizLink = document.querySelector('a[href="#quiz-meHJPM"]');
if (quizLink) {
    quizLink.addEventListener('click', function () {
        setTimeout(function() {
            $("#meHJPM iframe")[0].contentWindow.focus();
        }, 100);
    });
}

/* End ADA: When opening the Spice Quiz, the focus should be moved to the Spice Quiz iframe */

/***/

/* Start ADA: Add the ability to navigate the nested dropdown menus using the keyboard */

const allNavDropdowns = $('.site-nav__dropdown');
const allNavDropdownsItems = allNavDropdowns.find("li");
const allNavDropdownsAnchors = allNavDropdowns.find("a");
allNavDropdownsItems.attr("tabindex", "-1");
allNavDropdownsAnchors.attr("tabindex", "-1");

$(".site-nav__link--main").on('keydown', function (event) {
    if ($(this).parent().hasClass('site-nav--has-dropdown') && event.key === 'ArrowDown') {
        event.preventDefault();
        const currentDropdown = $(this).parent().find('.site-nav__dropdown');
        const currentDropdownItems = currentDropdown.find("li");
        currentDropdown.addClass("dropdownHover");
        currentDropdownItems.first().focus();
    }
});

allNavDropdownsItems.on('keydown', function (event) {
    let currentItem = $(this);
    if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (currentItem.next().css('display') == 'none') {
            // some items are hidden due to an A/B test
            currentItem = $(this).next();
        }
        if (currentItem.is(':last-child')) {
            const grandparent = currentItem.parent().parent();
            if (grandparent.hasClass('menu_list_wrap')) {
                const grandparentNextSibling = grandparent.next();
                const grandparentFirstSibling = grandparent.siblings(':first');
                if (grandparentNextSibling.hasClass('menu_list_wrap')) {
                    grandparentNextSibling.find("li").first().focus();
                } else if (grandparentFirstSibling.hasClass('menu_list_wrap')) {
                    grandparentFirstSibling.find("li").first().focus();
                }
            } else {
                currentItem.parents('.site-nav__dropdown').find("li").first().focus();
            }
        } else {
            currentItem.next().focus();
        }
    } else if (event.key === 'ArrowUp') {
        if (currentItem.prev().css('display') == 'none') {
            // some items are hidden due to an A/B test
            currentItem = $(this).prev();
        }
        event.preventDefault();
        if (currentItem.is(':first-child')) {
            const grandparent = $(this).parent().parent();
            if (grandparent.hasClass('menu_list_wrap')) {
                const grandparentPrevSibling = grandparent.prev();
                const grandparentLastSibling = grandparent.siblings(':last');
                if (grandparentPrevSibling.hasClass('menu_list_wrap')) {
                    grandparentPrevSibling.find("li").last().focus();
                } else if (grandparentLastSibling.hasClass('menu_list_wrap')) {
                    grandparentLastSibling.find("li").last().focus();
                }
            } else {
                currentItem.parents('.site-nav__dropdown').find("li").last().focus();
            }
        } else {
            currentItem.prev().focus();
        }
    } else if (event.key === 'Tab' || event.key === 'Escape') {
        event.preventDefault();
        const currentDropdown = currentItem.parents('.site-nav__dropdown')
        currentDropdown.removeClass("dropdownHover");
        currentDropdown.parent().find('.site-nav__link--main').focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.target.querySelector('a').click();
    }
});
$(document).on('click', function(event) {
    if (!event.target.closest(".site-nav--has-dropdown")) {
        allNavDropdowns.removeClass("dropdownHover");
    }
});

/* End ADA: Add the ability to navigate the nested dropdown menus using the keyboard */

/***/

/* Start ADA: When the home page's video button is clicked, move focus to the video lightbox */

$('.index-welcome-custom-sub-btn a, a.pdp-video-play-button').on('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.target.click();
    }
});
const videoIframeObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.addedNodes) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {
                if (mutation.addedNodes[i].id === "html5box-html5-lightbox") {
                    const iframe = mutation.addedNodes[i].querySelector("#html5boxiframevideo0");
                    iframe.setAttribute("tabindex", "0");
                    iframe.focus();
                    waitForElm("#html5-close")
                    .then(closeBtn => closeBtn
                        .addEventListener('keydown', function(event) {
                            if (event.key === 'Enter' || event.key === ' ') {
                                event.preventDefault();
                                event.target.click();
                                document.querySelector('.index-welcome-custom-sub-btn a').focus();
                            }
                        })
                    );
                    break;
                } else if (mutation.addedNodes[i].classList && mutation.addedNodes[i].classList.contains("mfp-wrap")) {
                    const closeButton = mutation.addedNodes[i].querySelector(".mfp-close");
                    closeButton.setAttribute("tabindex", "0");
                    const iframe = mutation.addedNodes[i].querySelector(".mfp-iframe");
                    iframe.setAttribute("tabindex", "0");
                    break;
                }
            }
        }
    });
});
videoIframeObserver.observe(document.body, { childList: true });

// When the user tabs out of the lightbox, move focus back to it
$(document).on('keydown', function(event) {
    if (event.key === 'Tab') {
        const lightbox = $("#html5-lightbox-box");
        if (lightbox.length && !$(event.target).parents("#html5-lightbox-box").length) {
            lightbox.find("#html5boxiframevideo0").focus();
        }
    }
});

/* End ADA: When the home page's video button is clicked, move focus to the video lightbox */

/***/

/* Start ADA: Make “Order Note” and “Gift Note” focusable and navigable.
**
** $(".cart-note__label").on('keydown', function(event) {
**     if (event.key === 'Enter' || event.key === ' ') {
**         event.preventDefault();
**         event.target.click();
**         $(event.target).siblings('.textarea_display').find('textarea').focus();
**     }
** });
** $("#how-did-you-hear-about-us, #CartSpecialInstructions").on('keydown', function (event) {
**     if (event.key === 'Tab') {
**         const parent = $(this).parents('.textarea_display')
**         parent.siblings('.cart-note__label').removeClass('active');
**         parent.slideToggle(500);
**     }
** });
**
** End ADA: Make “Order Note” and “Gift Note” focusable and navigable. */

/***/

/* Start ADA: Make the tooltip icon focusable and navigable. */

$(".gift_options_product .tooltip").on('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(event.target).trigger('mouseover');
    }
});

/* End ADA: Make the tooltip icon focusable and navigable. */

/***/
    
/* Start ADA: Pressing enter on the reviews badge/link under the product title
should scroll to the reviews. */
    
$(".product-single .product-single__meta .display_inline .stamped-product-reviews-badge")
.on('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $("#stamped-main-widget").offset().top - 100
        }, 1000);
    }
});

/* End ADA: Pressing enter on the reviews badge/link under the product title
should scroll to the reviews. */
    
/***/
    
/* Start ADA: The featured review should be focusable and selectable. */

waitForElm(".stamped-reviews-message").then(elm => {
    elm.setAttribute("tabindex", "0");
    elm.addEventListener("keydown", function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.target.click();
        }
    });
});

/* Start ADA: The featured review should be focusable and selectable. */
    
/***/
    
/* Start ADA: Accordion content shouldn’t be navigable when hidden
(e.g.: Pressing the tab key on the “Health Benefits” accordion goes to the links
within its content even when it is not active). */

$(".accordion-panel")
.find("a, area, button, frame, iframe, input, object, select, textarea, summary")
.attr("tabindex", "-1");

$("button.accordion").on("click", function (event) {

    const accordion = event.target;
    const accordionPanel = event.target.nextElementSibling;

    if (accordion.classList.contains("active")) {
        $(accordionPanel)
        .find("a, area, button, frame, iframe, input, object, select, textarea, summary")
        .attr("tabindex", "0");
    } else {
        $(accordionPanel)
        .find("a, area, button, frame, iframe, input, object, select, textarea, summary")
        .attr("tabindex", "-1");
    }

});

/* End ADA: Accordion content shouldn’t be navigable when hidden
(e.g.: Pressing the tab key on the “Health Benefits” accordion goes to the links
within its content even when it is not active). */
    
/***/
    
/* Start ADA: Fix issue with the product recommendations slides outline not showing
properly, and send the focus to the link inside them instead */
    
setTimeout(function () {
    $(".template-product .product-recommendations-products .grid__item.slick-slide").on("keyup", function (event) {
        if (event.target !== this)
            return;
        if (event.key === 'Tab' && !event.shiftKey) {
            $(this).find(".grid-view-item__link").focus();
        } else if (event.key === 'Tab' && event.shiftKey) { 
            const prev = $(this).prev();
            if (prev.attr("tabindex") === "0") {
                prev.find(".grid-view-item__link").focus();
            } else {
                $(this).parents(".slick-list").siblings(".slick-arrow.slick-prev").focus();
            }
        }
    });
}, 1000);

/* End ADA: Fix issue with the product recommendations slides outline not showing
properly, and send the focus to the link inside them instead */
    
/***/

/* Start ADA: Fix issues with the Stamped Reviews widget's keyboard navigation */

// Remove the onkeyup attribute from the main carousel, this is so that it doesn't
// automatically open when Tab is pressed. It should only open when the user presses Enter or Space.
$(".stamped-photos-carousel .stamped-photo a").removeAttr("onkeyup");

// Remove the onkeydown attribute from the "Write a Review" and "Ask a Question" buttons,
// this is so that they don't automatically open when Tab is pressed. They should only open
// when the user presses Enter or Space.
$(".stamped-summary-actions-newreview").removeAttr("onkeydown");
$(".stamped-summary-actions-newquestion").removeAttr("onkeydown");

// Make summary ratings focusable and selectable.
$(".stamped-summary-ratings").find(".summary-rating").attr("tabindex", "0");

// Remove focus from the hidden rating input of othe review form.
$("#reviewRating").attr("tabindex", "-1");

// Fix issues with the review form star rating using the keyboard.
const stampedFormReviewRating = $(".stamped-form-review-rating");
stampedFormReviewRating.find(".stamped-form-input.stamped-starrating a").removeAttr("onkeydown");
stampedFormReviewRating.on("keydown", function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.target.click();
    }
});

// Make the review form file uploader focusable and selectable.
const stampedFileUploaderBtn = $(".stamped-file-uploader-btn");
stampedFileUploaderBtn.attr("tabindex", "0");
stampedFileUploaderBtn.siblings("#stamped-file-uploader-input").attr("tabindex", "-1");
stampedFileUploaderBtn.on("keydown", function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.target.click();
    }
});

// When escape is pressed to close one of the main carousel's images, focus should
// return back to the image thumbnail that was pressed to open it.
function focusPrevThumbnailUponEscapingModal(event) {
    const image = event.target;
    const stampedUGCModalObserver = new MutationObserver(function (mutations) {{}
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes) {
                const stampedUGCmodal = $(mutation.addedNodes).filter(".stamped-ugc-modal");
                if (stampedUGCmodal.length) {
                    stampedUGCmodal.on("keydown", function (modalEvent) {
                        // if (modalEvent.key === 'Tab' && !modalEvent.shiftKey) {
                        //     const stampedUGCmodalCloseButton = stampedUGCmodal.find(".stamped-modal-close");
                        //     stampedUGCmodalCloseButton.focus();
                        //     stampedUGCmodalCloseButton.on("keydown", function (closeEvent) {
                        //         if (closeEvent.key === 'Tab' && !closeEvent.shiftKey) {
                        //             closeEvent.preventDefault();
                        //             stampedUGCmodal.find(".stamped-ugc-modal-vote-up").focus();
                        //         }
                        //     });
                        // } else 
                        if (modalEvent.key === 'Escape') {
                            image.focus();
                        }
                    });
                }
            }
        });
    });
    stampedUGCModalObserver.observe(document.body, { childList: true, subtree: true });
}
$(".stamped-photos-carousel .stamped-photo a")
.on("click", focusPrevThumbnailUponEscapingModal);

// Observe ".stamped-review-image a" elements and remove the onkeyup attribute,
// then also add a click event listener to them to focus the previous thumbnail when
// the modal is closed with the escape key.
// The mutation observer is needed because of the widget's pagination.
const stampedContent = document.querySelector(".stamped-content");
if (stampedContent) {
    const stampedReviewImageObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes) {
                $(stampedContent).find(".stamped-review-image a").removeAttr("onkeyup");
                $(stampedContent).find(".stamped-review-image a").on("click", focusPrevThumbnailUponEscapingModal);
            }
        });
    });
    stampedReviewImageObserver.observe(stampedContent, { childList: true, subtree: true });
}

/* End ADA: Fix issues with the Stamped Reviews widget's keyboard navigation */
    
/***/
    
/*
** Start ADA: BBP: Lightbox:
** - The focus should move to the product description Lightbox when a user presses “Read more”
** - The focus should move to "Read more" when a user exits the Lightbox
** - Keep the focus on the Lightbox when a user presses Tab or Shift + Tab on its boundaries
** - If the user presses Escape when the Lightbox is open, the Lighbox should close and the focus should move to "Read more"
*/

waitForElm(".bundle-builder-app--bundle--product--show-more").then(function () {
    $(".bundle-builder-app--bundle--product--show-more").on("keydown", function (showMoreEvent) {
        if (showMoreEvent.key === 'Enter') {
            const readMoreBtn = $(showMoreEvent.target);
            waitForElm(".bundle-builder-app--bundle-contents-modal--close").then(function (closeBtn) {
                $(closeBtn).focus();
                $(closeBtn).siblings().find(".bundle-builder-app--product-image-slider--button").attr("tabindex", "-1");
                const addProductBtn = $(closeBtn).siblings().find(".bundle-builder-app--bundle--product-add--wrapper button.bundle-builder-app--bundle--product-add-button");
                const lightbox = $(closeBtn).parent();
                $(closeBtn).on("keydown", function (closeEvent) {
                    if (closeEvent.key === 'Enter' || closeEvent.key === ' ') {
                        closeEvent.preventDefault();
                        $(closeBtn).click();
                        if (readMoreBtn.is("a")) {
                            readMoreBtn.focus();
                        } else {
                            readMoreBtn.parent().focus();
                        }
                    } else if (closeEvent.key === 'Tab' && closeEvent.shiftKey) {
                        closeEvent.preventDefault();
                        addProductBtn.focus();
                    }
                });
                addProductBtn.on("keydown", function (addProductEvent) {
                    if (addProductEvent.key === 'Tab' && !addProductEvent.shiftKey) {
                        addProductEvent.preventDefault();
                        $(closeBtn).focus();
                    }
                });
                lightbox.on("keydown", function (lightboxEvent) {
                    if (lightboxEvent.key === 'Escape') {
                        lightboxEvent.preventDefault();
                        $(closeBtn).click();
                        if (readMoreBtn.is("a")) {
                            readMoreBtn.focus();
                        } else {
                            readMoreBtn.parent().focus();
                        }
                    }
                });
            });
        }
    });
});

/* End ADA: BBP: Lightbox */

/***/

/* Start making a carousel for the recipes section (code copied from "product-recommendations.liquid" and modified) */

$(document).ready(function() {
  
  const sliderElement = $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)')[0];

  if (sliderElement) {

    const width = $(window).width();

    /*
    if(width > 1500) {
      $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)').on('setPosition', function () { $(this).find('.slick-list').css('padding', '0 100px'); }).slick({ slidesToShow: 4, slidesToScroll: 4 });
    } else if(width >= 1250) {
      $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)').on('setPosition', function () { $(this).find('.slick-list').css('padding', '0 70px'); }).slick({ slidesToShow: 4, slidesToScroll: 4 });
    } else if(width >= 1024) {
      $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)').on('setPosition', function () { $(this).find('.slick-list').css('padding', '0 50px'); }).slick({ slidesToShow: 3, slidesToScroll: 3 });
    } else if(width >= 600) {
      $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)').on('setPosition', function () { $(this).find('.slick-list').css('padding', '0 30px'); }).slick({ slidesToShow: 2, slidesToScroll: 2 });
    } else if(width >= 480) {
      $('.index-section.multiple-product-section .custom-content.multiple-product-items:has(.recipe-card)').on('setPosition', function () { $(this).find('.slick-list').css('padding', '0 15px'); }).slick({ slidesToShow: 1, slidesToScroll: 1 });
    }
    */

    const numberOfSlides = sliderElement.children.length;

    if (width > 1024) {
      if (numberOfSlides < 4) {
        $(sliderElement).find("> li").css("max-width", "280px");
      }
    } else if (width > 749) {
      if (numberOfSlides < 3) {
        $(sliderElement).find("> li").css("max-width", "280px");
      }
    }
  
    $(sliderElement).slick({
      dots: false,
      infinite: true,
      centerMode: true,
      speed: 300,
      slidesToShow: numberOfSlides >= 6 ? 6 : numberOfSlides,
      slidesToScroll: numberOfSlides >= 6 ? 6 : numberOfSlides,
      centerPadding: "100px",
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            slidesToShow: numberOfSlides >= 5 ? 5 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 5 ? 5 : numberOfSlides
          }
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: numberOfSlides >= 4 ? 4 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 4 ? 4 : numberOfSlides
          }
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: numberOfSlides >= 3 ? 3 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 3 ? 3 : numberOfSlides
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: numberOfSlides >= 2 ? 2 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 2 ? 2 : numberOfSlides
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerPadding: "40px",
            slidesToShow: numberOfSlides >= 2 ? 2 : numberOfSlides,
            slidesToScroll: numberOfSlides >= 2 ? 2 : numberOfSlides
          }
        },
        {
          breakpoint: 510,
          settings: {
            centerPadding: "50px",
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: numberOfSlides > 1 ? true : false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    })

  }

});

/* End making a carousel for the recipes section (code copied from "product-recommendations.liquid") */

/***/

/* Start hiding ATC buttons on sold out variants */

$('.variant-btn .varint-lbl label').click(function() {
    const ATCButtons = $(this).parents("form#AddToCartForm").find("div.form_inline.quantity_inline");
    if ($(this).data("soldout-text")) {
        ATCButtons.addClass("hidden")
    } else {
        ATCButtons.removeClass("hidden")
    }
});

/* End hiding ATC buttons on sold out variants */

/***/

/* Start changing the press logos to a slider on mobile */

$(document).ready(function() {
    $(window).on('load resize orientationchange', function () {
        if (window.innerWidth <= 992) {
            if (!$('.press-logos-slider').hasClass('slick-initialized')) {
                $('.press-logos-slider').slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    autoplay: true,
                  	autoplaySpeed: 4000,
                    speed: 500,
                    accessibility: false
                });
            }
        } else {
            if ($('.press-logos-slider').hasClass('slick-initialized')) {
                $('.press-logos-slider').slick('unslick');
            }
        }
    });
});

/* End changing the press logos to a slider on mobile */

/***/

/* Start ADA: Keep the PDP carousels outlined while R&L arrow keys are used */

$(document).ready(function() {
    const productPageCarousel = $(".gallery-mob-slider");
    const productPageCarouselNav = $(".gallery-mob-slider-nav");
    productPageCarousel.add(productPageCarouselNav).on("keydown", function(e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            $(this).addClass("focus");
        } else {
            $(this).removeClass("focus");
        }
    });
    $(document).on("click", function(e) {
        if (!$(e.target).closest(productPageCarousel).length) {
            productPageCarousel.removeClass("focus");
        }
        if (!$(e.target).closest(productPageCarouselNav).length) {
            productPageCarouselNav.removeClass("focus");
        }
    });
});

/* End ADA: Keep the PDP carousels outlined while R&L arrow keys are used */

/***/

/* Start ADA: Make PDP’s nav carousel items selectable (using Enter or Space) when focused */

$(document).ready(function() {
    const productPageCarouselNavItems = $(".gallery-mob-slider-nav .product-single__photo-wrapper.js.show.slick-slide");
    productPageCarouselNavItems.on("keydown", function(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).click();
        }
    });
});

/* End ADA: Make PDP’s nav carousel items selectable (using Enter or Space) when focused */

/***/

/* Start ADA: “Recipes” blog page: Make the filters focusable and navigable */

$(document).ready(function() {
  const filter = $(".blog-sidebar");
  const filterTitles = filter.find(".nav-title");
  const filterItems = filter.find(".nav-list li");
  filterTitles
  .add(filterItems)
  .on("keydown", function(e) {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $(this).click();
    }
  });
});

/* End ADA: “Recipes” blog page: Make the filters focusable and navigable */

/***/

/* Start Comparison Table */

$(document).ready(function() {
    $(window).on('load hashchange', function () {
        if (window.location.hash === "#spice-comparison-chart") {
            setTimeout(function() {

                const tableAnchor = $("#spice-comparison-chart:target");
                const tableContainer = tableAnchor.find("div.comparison-table__chart");
                const table = tableContainer.find("table.comparison-table__chart--table");

                table.click(function(e) {
                    e.preventDefault();
                });

                const closeBtn = tableContainer.find(".close_button");
                tableContainer.scroll(function() {
                    if (window.innerWidth > 749) {
                        closeBtn.css("top", 8 + tableContainer.scrollTop() + "px");
                    }
                });

                if (table.width() > tableContainer.width()) {
                    const colMinWidth = tableContainer.width() - table.find("th.comparison-table__chart--title").width();
                    table.find("th:not(:first-child)").css("min-width", colMinWidth + "px");
                    tableContainer.css("scroll-snap-type", "x mandatory");
                    table.find("th:not(:first-child)").css("scroll-snap-align", "end");
                    table.find("th:nth-child(2)").css("scroll-margin-right", "-6px");
                    table.find("th").css("scroll-snap-stop", "always");
                }

            }, 100);
        }
    });
});

/* End Comparison Table */

/***/

/* Start "Carousel with Info" section */

$('.carousel-with-info__carousel').slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
  	autoplaySpeed: 4000,
    speed: 500,
    accessibility: false
});

/* End "Carousel with Info" section */

/***/

/* Start: Move "Get the Spices for This Recipe" section to the middle of the recipe page */

if (window.location.href.indexOf("/blogs/recipes") > -1) {
    waitForElm("#shopify-section-recipes-products").then(function(recipeProductsSection) {
        if (window.articleRecipesProducts?.length) {
            const mainContent = $(recipeProductsSection).parents("#MainContent");
            mainContent.find("#rk_design .rk_container .rk_card .rk_header").after(recipeProductsSection);
        } else {
            recipeProductsSection.remove();
        }
    });
}

/* End: Move "Get the Spices for This Recipe" section to the middle of the recipe page */

/***/

/* Start adding JS to collapse/expand the Gift Options section on the cart drawer */

function toggleGiftOptionsContent(giftOptionsTitle) {
    const giftOptions = $(giftOptionsTitle).parents(".gift_options");
    const cartDrawerFooter = giftOptions.parents(".cart-drawer-right").find(".drawer_footer_main");
    giftOptions.find(".gift_options_content").toggle();
    if (giftOptions.hasClass("collapsed")) {
        cartDrawerFooter.addClass("gift_options_expanded");
        giftOptions[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    } else {
        cartDrawerFooter.removeClass("gift_options_expanded");
        giftOptions[0].scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }
    giftOptions.toggleClass("collapsed");
}

/* End adding JS to collapse/expand the Gift Options section on the cart drawer */

/***/

/* Start collapsing the Gift Options section on the cart drawer when the drawer is scrolled to the top */

$(document).ready(function() {
    $(".cart-drawer-right").scroll(function() {
        const giftOptions = $(this).find(".gift_options:not(.upsell_reproducts)");
        if ($(this).scrollTop() <= 0) {
            giftOptions.addClass("collapsed");
            giftOptions.find(".gift_options_content").hide();
        }
    });
});

/* End collapsing the Gift Options section on the cart drawer when the drawer is scrolled to the top */

/***/

/* Start toggling Gift Options products depending on whether they are already in the cart */

function toggleGiftOptionsProducts() {

    let cartSelectors = ["#CartDrawer"];

    if (window.location.href.indexOf("/cart") > -1) {
        cartSelectors.push("#shopify-section-cart-template");
    }

    cartSelectors.forEach(function(cartSelector) {

       let cartProducts;
       let cartProductsWithSameIDSelector;

       if (cartSelector === "#CartDrawer") {
           cartProducts = $(".cart-drawer-right .ajax_drawer_products");
           cartProductsWithSameIDSelector = ".ajaxcart__product[data-itemid='";
       } else {
           cartProducts = $(".cart-page-content form.cart tbody");
           cartProductsWithSameIDSelector = "tr.cart__row[data-cart-item-key^='";
       }

       let giftOptions = $(cartSelector).find(".gift_options");
       let giftOptionsProducts = giftOptions.find(".gift_options_product");
       let numberOfGiftOptionsProductsFoundInCart = 0;

       giftOptionsProducts.each(function() {

           const giftOptionsProductID = $(this).attr("data-id");
           const cartProductsWithSameID = cartProducts.find(cartProductsWithSameIDSelector + giftOptionsProductID + "']");

           if (cartProductsWithSameID.length > 0) {
               $(this).hide();
               numberOfGiftOptionsProductsFoundInCart++;
           } else {
               $(this).show();
           }

       });

       const giftOptionsSubtitle = giftOptions.find(".gift_options_subtitle");
       if (numberOfGiftOptionsProductsFoundInCart === giftOptionsProducts.length) {
           giftOptionsSubtitle.hide();
       } else {
           giftOptionsSubtitle.show();
       }

    });
    
}

if (window.location.href.indexOf("/cart") > -1) {
    toggleGiftOptionsProducts();
}

/* End toggling Gift Options products depending on whether they are already in the cart */

/***/

/* Start Gift Options tooltip */

$(".gift_options_product .tooltip").on('click mouseover', showTooltip);
$(".gift_options_product .tooltip__close").on('click', hideTooltip);

function showTooltip(event) {

    const tooltipIcon = $(event.currentTarget);
    const tooltipContent = tooltipIcon.closest(".gift_options_product").find(".tooltip-content");

    console.log(tooltipContent.css('left'));

    if (tooltipContent.css('left') === '0px') {

        const product = tooltipIcon.closest(".gift_options_product");
        const productWidth = product.width();
        const productX = product.offset().left;
        const tooltipContentX = tooltipContent.offset().left;
        const tooltipContentWidth = tooltipContent.width();
        const tooltipContentLeft = productX - tooltipContentX + (productWidth / 2) - (tooltipContentWidth / 2);
        tooltipContent.css('left', tooltipContentLeft);

        const tooltipContentTriangleInner = tooltipContent.children('.tooltip-content-triangle-inner');
        const tooltipContentTriangleOuter = tooltipContent.children('.tooltip-content-triangle-outer');
        const tooltipIconX = tooltipIcon.offset().left;
        const tooltipIconLeft = tooltipIconX - productX - tooltipContentLeft + 5;
        tooltipContentTriangleInner.css('left', tooltipIconLeft - 15 >= 0 ? tooltipIconLeft : 15);
        tooltipContentTriangleOuter.css('left', tooltipIconLeft - 15 >= 0 ? tooltipIconLeft - 15 : 0);

    }

    tooltipContent.addClass('show-tooltip');

}

function hideTooltip(event) {
    event.stopPropagation();
    const tooltipIcon = $(event.currentTarget);
    const tooltipContent = tooltipIcon.closest(".gift_options_product").find(".tooltip-content");
    tooltipContent.removeClass('show-tooltip');
}

$(document).on('click', function(event) {
    if (!$(event.target).closest('.tooltip').length) {
        $(".gift_options_product .tooltip-content").removeClass('show-tooltip');
    }
});

/* End Gift Options tooltip */

/***/

/* Start hiding border-top on the drawer footer when the drawer is scrolled to the bottom */
/* 
** $(document).ready(function() {
**     $(".cart-drawer-right .drawer-header-products").scroll(function() {
**         const drawerFooterMain = $(this).parents(".cart-drawer-right").find(".drawer_footer_main");
**         if ($(this).scrollTop() + $(this).innerHeight() >= ($(this)[0].scrollHeight - 1)) {
**             drawerFooterMain.addClass("no-border-top");
**         } else {
**             drawerFooterMain.removeClass("no-border-top");
**         }
**     });
** });
*/ 
/* End hiding border-top on the drawer footer when the drawer is scrolled to the bottom */

/***/

/* Start filtering out undesired tags from the Bundel Builder filter */

waitForElm("select.bundle-builder-app--bundle--filter--select").then(function(filterSelect) {
    const filterOptions = $(filterSelect).find("option");
    const desiredTags = ["Filter", "All Spices", "New!", "Best Sellers", "Spice Sets & Gifts", "Everyday Basics", "Collabs", "Blends", "Cardamom", "Chilis & Paprikas", "Cinnamon", "Peppercorns", "Vanilla", "Herbs"];
    filterOptions.each(function() {
        if (!desiredTags.includes($(this).text())) {
            $(this).remove();
        } else if ($(this).text() === "Filter") {
            $(this).text("All Spices");
            $(this).removeAttr("disabled");
        }
    });
});

/* End filtering out undesired tags from the Bundel Builder filter */

/***/

/* Start showing a "Show More" button on the Categories section of the PDP */

const pdpCategoriesSection = $(".template-product .tags");
const pdpCategories = pdpCategoriesSection.find(".tag-item");
const showMoreButton = "<a class='tag-item tags__show-more' href='#'>Show More</a>";
const showLessButton = "<a class='tag-item tags__show-less' href='#'>Show Less</a>";

if (pdpCategories.length > 4) {
    pdpCategories.slice(4).hide();
    pdpCategoriesSection.append(showMoreButton);
}

pdpCategoriesSection.on("click", ".tags__show-more", function(e) {
    e.preventDefault();
    pdpCategories.slice(4).show();
    $(e.target).replaceWith(showLessButton);
});

pdpCategoriesSection.on("click", ".tags__show-less", function(e) {
    e.preventDefault();
    pdpCategories.slice(4).hide();
    $(e.target).replaceWith(showMoreButton);
});

/* End showing a "Show More" button on the Categories section of the PDP */

/***/

/* Start adding the Bundle Builder banners */

const isBundleBuilder = window.location.href.includes("apps/bundles/bundle");
if (isBundleBuilder) {
  const bannersHTML = `
    <div class="bundle-builder__header collection-hero-wrapper collection-alternate-banner"> 
      <div class="collection-hero" style="background-image: url(https://cdn.shopify.com/s/files/1/2554/1458/files/collection-banner-bg.jpg?v=1650915632);">
       
        <div class="collection-hero__title-wrapper collection-hero__title">
          <div class="page-width">
            <h1>Bundle & Save</h1>
            
            <div class="rte collection-description page-width small--hide">              
              <p>Beautifully packed gift set with 3 or more spices.<br />Add a gift note in the cart.</p>
            </div>
            
            <div class="rte collection-description page-width medium-up--hide">
              <p>Beautifully packed gift set with 3 or more spices.<br />Add a gift note in the cart.</p>
            </div>

          </div>
        </div>
      </div>
    </div>
  
    <div class="bundle-builder__banner">
      <div class="page-width">
        <div class="bundle-builder__banner-content">
          <p>Sets are packed as multiples of 3 or 6.<br />Extra jars will be packed outside the gift box.</p>
          <div class="bundle-builder__banner-content__sets">
            <figure class="bundle-builder__banner-content__set">
              <div class="bundle-builder__banner-content__set-image">
                <img class="bundle-builder__banner-content__set-of-3" src="https://cdn.shopify.com/s/files/1/2554/1458/files/3_Spices.svg?v=1689866171" alt="3-Spices Gift Set" />
              </div>
              <figcaption class="bundle-builder__banner-content__set-title">3+ Spices</figcaption>
              <div class="bundle-builder__banner-content__set-savings">Save $1.99</div>
            </figure>
            <div class="bundle-builder__banner-content__other-sets">
              <figure class="bundle-builder__banner-content__set">
                <div class="bundle-builder__banner-content__set-image">
                  <img class="bundle-builder__banner-content__set-of-6" src="https://cdn.shopify.com/s/files/1/2554/1458/files/6_Spices.svg?v=1689866588" alt="6-Spices Gift Set" />
                </div>
                <figcaption class="bundle-builder__banner-content__set-title">6+ Spices</figcaption>
                <div class="bundle-builder__banner-content__set-savings">Save $2.99</div>
              </figure>
              <figure class="bundle-builder__banner-content__set">
                <div class="bundle-builder__banner-content__set-image">
                  <img class="bundle-builder__banner-content__set-of-9" src="https://cdn.shopify.com/s/files/1/2554/1458/files/9_Spices.svg?v=1689866588" alt="9-Spices Gift Set" />
                </div>
                <figcaption class="bundle-builder__banner-content__set-title">9+ Spices</figcaption>
                <div class="bundle-builder__banner-content__set-savings">Save $4.99</div>
              </figure>
              <figure class="bundle-builder__banner-content__set">
                <div class="bundle-builder__banner-content__set-image">
                  <img class="bundle-builder__banner-content__set-of-12" src="https://cdn.shopify.com/s/files/1/2554/1458/files/12_Spices.svg?v=1689866589" alt="12-Spices Gift Set" />
                </div>
                <figcaption class="bundle-builder__banner-content__set-title">12+ Spices</figcaption>
                <div class="bundle-builder__banner-content__set-savings">Save $6.99</div>
              </figure>
              <p class="bundle-builder__banner-content__other-sets__free-shipping">Free shipping in the U.S.!</p>
            </div>
          </div>
          <a class="bundle-builder__banner-content__best-selling-link" href="/collections/gifts">
            <figure class="bundle-builder__banner-content__best-selling">
              <div class="bundle-builder__banner-content__best-selling-image">
                <img src="https://cdn.shopify.com/s/files/1/2554/1458/files/Bestsellers_icon_53654e4a-0060-4427-a562-b9e5e628849c.svg?v=1689867657" alt="Illustration of a Gift" />
              </div>
              <figcaption><span>Check out our</span><span>bestselling gift sets</span></figcaption>
            </figure>
          </a>
        </div>
      </div>
    </div>
  `
  $('#MainContent').prepend(bannersHTML);
  waitForElm("#MainContent h1.bundle-builder-app--bundle--name").then(function(bundleBuilderOriginalTitle) {
    $(bundleBuilderOriginalTitle).remove();
  });
  waitForElm("#MainContent .bundle-builder-app--bundle--description ").then(function(bundleBuilderOriginalDescription) {
    $(bundleBuilderOriginalDescription).remove();
  });
}

/* End adding the Bundle Builder banners */

/***/

/* Start: On PageFly pages, open the cart drawer when clicking on the "Add to Cart" button */

if (window.location.href.includes("/pages/")) {
    if (window.__pagefly_helper_init) {
        xhook.after(function (request, response) {
            if (request && (request.url.includes("/cart/add.js"))) {
                ajaxCart.load();
            }
        });
    }
}

/* End: On PageFly pages, open the cart drawer when clicking on the "Add to Cart" button */

/***/

/* Start: Masala PDP's card slider */

$('.masala-card__carousel').slick({
    dots: true,
    infinite: true,
    arrows: false,
  	autoplaySpeed: 4000,
    speed: 500,
    accessibility: false
});

/* End: Masala PDP's card slider */

/***/

/* Start: Set sticky filters on colleciton pages to full width */

$(document).ready(function() {
    $(window).on('load resize orientationchange', function () {
        $(".filters-toolbar-wrapper").each(function() {
            const width = $(window).width();
            $(this).css("margin-inline", `calc((${width}px - 100%) / -2)`);
        });
    });
});

/* End: Set sticky filters on colleciton pages to full width */

/***/

/* Start: Change the buttons on the "Spice Up the Holidays" section into a carousel on mobile */

document.addEventListener("DOMContentLoaded", function() {
    $(window).on('load resize orientationchange', function () {
        if (window.innerWidth <= 749) {
            if (!$('.spice-up-the-holidays__buttons.is_carousel').hasClass('slick-initialized')) {
                $('.spice-up-the-holidays__buttons.is_carousel').slick({
                    infinite: false,
                    arrows: false,
                    dots: true,
                    slidesToShow: 2.5
                });
            }
        } else {
            if ($('.spice-up-the-holidays__buttons.is_carousel').hasClass('slick-initialized')) {
                $('.spice-up-the-holidays__buttons.is_carousel').slick('unslick');
            }
        }
    });
});

/* End: Change the buttons on the "Spice Up the Holidays" section into a carousel on mobile */

/***/

/* Start: Add an on-page search functionality to the Bundle Builder -- Code by: ConversionAdvocates */

const clearIconHtml = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"> <g clip-path="url(#clip0_169_17)"> <path d="M10.7406 9.50676L17.6027 2.65101C18.1022 2.15241 18.1022 1.40451 17.6027 0.90636C17.1036 0.40776 16.3548 0.40776 15.8558 0.90636L8.9937 7.76166L2.13165 0.90681C1.6326 0.40821 0.884249 0.40821 0.385199 0.90681C-0.114301 1.40541 -0.114301 2.15331 0.385199 2.65146L7.24725 9.50676L0.384749 16.3616C-0.113851 16.8602 -0.113851 17.6081 0.384749 18.1063C0.634499 18.3556 0.946349 18.4802 1.25865 18.4802C1.57095 18.4802 1.88235 18.3556 2.13165 18.1067L8.99415 11.2514L15.8558 18.1063C16.1055 18.3556 16.4174 18.4802 16.7292 18.4802C17.041 18.4802 17.3534 18.3556 17.6027 18.1067C18.1022 17.6077 18.1022 16.8602 17.6027 16.3616L10.7406 9.50676Z" fill="#3D4246"/> </g> <defs> <clipPath id="clip0_169_17"> <rect width="18" height="18" fill="white" transform="translate(0 0.5)"/> </clipPath> </defs> </svg>';

const expCss = '.bundle-builder-app--bundle--filter { gap: 0.5rem; } .ca-burlap-007-search { max-width: 430px; min-height: 48px; display: flex; justify-content: space-between; align-items: center; flex-grow: 1; gap: 10px; border: 1px solid var(--button-bg-color); border-radius: 0.5rem; padding: 0.625rem 1rem; margin-left: auto; margin-right: 0.5rem; } .ca-burlap-007-search input { width: calc(100% - 25px); flex-grow: 1; padding: 0; border: none !important; outline: none !important; outline-color: transparent !important; box-shadow: none !important; } .ca-burlap-007-search svg { width: 25px; height: 25px; max-width: 100%; max-height: 100%; object-fit: contain; object-position: center; } .ca-burlap-007-search input.input-active ~ .icon-search { display: none; } .ca-burlap-007-search .btn-clear { width: 18px; height: 18px; display: none; background: none; border: none; outline: none; box-shadow: none; padding: 0; margin: 0; } .ca-burlap-007-search input.input-active ~ .btn-clear { display: block; } @media screen and (max-width: 576px) { .bundle-builder-app--bundle--filter { flex-direction: column-reverse; align-items: flex-start; } .bundle-builder-app--bundle--filter--select { margin: 0 !important; } .bundle-builder-app--bundle--filter:before { content: none; } .ca-burlap-007-search { width: 100%; margin: 0; } }';

function debounce(fn, delay = 500) {
	let timeout;
	return function (...args) {
		if (!timeout) {
			timeout = setTimeout(() => (timeout = null), delay);
			return fn(...args);
		}

		clearTimeout(timeout);
		timeout = setTimeout(() => {
			timeout = null;
			fn(...args);
		}, delay);
	};
}

function filterProducts(productList, searchValue) {
	const productNodes = productList.querySelectorAll('.bundle-builder-app--bundle--product');

    const noResultsNode = document.querySelector('#no-results');
    let noResults = true;

	productNodes.forEach((item) => {
		const title = item.querySelector('h3').innerText;
		if (title.toLowerCase().includes(searchValue.toLowerCase())) {
			item.classList.remove('hidden');
            noResultsNode.classList.add('hidden');
            noResults = false;
        } else {
			item.classList.add('hidden');
        }
	});

    if (noResults) {
        noResultsNode.textContent = `Sorry, nothing found for "${searchValue}".`;
        noResultsNode.classList.remove('hidden');
    }
}
const dFilterProducts = debounce(filterProducts);

waitForElm('.bundle-builder-app--bundle--section--product-list').then(productList => {

	if (productList) {
		const wrapperNode = document.createElement('div');
		wrapperNode.classList.add('ca-burlap-007-search');

		const inputNode = document.createElement('input');
		inputNode.placeholder = 'Search for a spice to bundle';

        const noResultsNode = document.createElement('p');
        noResultsNode.id = 'no-results';
        noResultsNode.classList.add('hidden');
        productList.parentNode.append(noResultsNode);

		const handleInputChange = () => {
			const productList = document.querySelector('.bundle-builder-app--bundle--section--product-list');

			inputNode.className = `${inputNode.value.length > 0 && 'input-active'}`;

			dFilterProducts(productList, inputNode.value);
		};

		inputNode.addEventListener('input', handleInputChange);
		const searchIcon = document.querySelector('.icon.icon-search').cloneNode(true);
		searchIcon.classList.add('icon-search');

		// + make handleInputChange a separate function
		// + append clear icon
		const clearIcon = document.createElement('button');
		clearIcon.innerHTML = clearIconHtml;
		clearIcon.classList.add('btn-clear');
		// + add click listener to clear icon:
		clearIcon.addEventListener('click', () => {
			inputNode.value = '';
			handleInputChange();
		});
		// + append btn

		wrapperNode.append(inputNode, searchIcon, clearIcon);

		const bundleFilterNode = document.querySelector('.bundle-builder-app--bundle--filter');
		bundleFilterNode.append(wrapperNode);

		const observer = new MutationObserver(() => {
			const productList = document.querySelector('.bundle-builder-app--bundle--section--product-list');
			dFilterProducts(productList, inputNode.value);

			const clearFilterBtn = document.querySelector('.bundle-builder-app--bundle--filter--clear-button');
			clearFilterBtn.addEventListener('click', () => {
				inputNode.value = '';
				filterProducts(productList, '');
			});
		});
		observer.observe(document.querySelector('.bundle-builder-app--bundle--section--product-list'), {
			childList: true,
			subtree: true
		});

		const style = document.createElement('style');
		style.innerHTML = expCss;
		document.head.append(style);

	}

});

/* End: Add an on-page search functionality to the Bundle Builder -- Code by: ConversionAdvocates */

/***/

/* Start custom dropdown */

$(document).ready(function() {
  $('.custom-dropdown__selected').click(function() {
    $(this).parent().toggleClass('custom-dropdown--open');
  });
  $('.custom-dropdown__list-item').click(function() {
    var selectedText = $(this).find('.custom-dropdown__list-item-text').text();
    $(this).closest('.custom-dropdown').find('.custom-dropdown__selected-text').text(selectedText);
    $(this).closest('.custom-dropdown').removeClass('custom-dropdown--open');
  });
  $(document).mouseup(function(e) {
      var container = $('.custom-dropdown');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('custom-dropdown--open');
      }
  });
});

/* End custom dropdown */

/***/

/* Fix PDP recipes anchoring */

$(document).ready(function() {
    if (window.location.hash == "#OurRecipes") {
        let ourRecipesSection = $(window.location.hash + '_hash');
        if (ourRecipesSection.length) {
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: ourRecipesSection.offset().top - 80
                }, 500);
            }, 1000);
        }
    }
});